/**
 * Chuỗi UI Web Viewer (design 09b). Key phẳng, namespace theo khu vực.
 * vi = NGUỒN (verbatim từ code). en = dịch tay. ru/zh/th = NHÁP máy-dịch — ⚠ CHỜ NGƯỜI BẢN NGỮ DUYỆT.
 * Số nhiều: key `*.one/.few/.many/.other` (dùng qua `tn`). Giữ nguyên brand/kỹ thuật: WoodViewer, mm, QR, X-ray, iframe, Aventos, Piston…
 */
import type { Dict, Locale } from '@wood-viewer/shared';

const vi: Dict = {
  'app.loading': 'Đang tải mô hình…',
  'app.noToken': 'Không tìm thấy mã mô hình trong đường dẫn.',
  'app.retry': 'Thử lại',
  'err.private.title': 'Mô hình riêng tư',
  'err.private.body': 'Mô hình này ở chế độ riêng tư. Bạn cần link Author từ chủ sở hữu để xem.',
  'err.notfound.title': 'Không tìm thấy mô hình',
  'err.notfound.body': 'Đường dẫn không tồn tại hoặc đã hết hạn. Vui lòng kiểm tra lại link với người gửi.',
  'err.version.title': 'Cần cập nhật trình xem',
  'err.version.body': 'Mô hình dùng định dạng mới hơn trình xem hiện tại. Vui lòng thử lại sau.',
  'err.empty.title': 'Mô hình trống',
  'err.empty.body': 'Mô hình này chưa có chi tiết nào để hiển thị.',
  'err.network.title': 'Không tải được mô hình',
  'err.network.body': 'Có lỗi kết nối. Vui lòng kiểm tra mạng và thử lại.',
  'err.webgl.title': 'Không hiển thị được mô hình 3D',
  'err.webgl.body':
    'Trình duyệt chưa bật tăng tốc phần cứng (WebGL) trên máy này. Hãy bật "Sử dụng tăng tốc phần cứng" trong cài đặt trình duyệt rồi khởi động lại, cập nhật driver card đồ họa, hoặc thử trình duyệt khác. Nếu bạn đang dùng qua Remote Desktop/máy ảo thì hãy mở trực tiếp trên máy có card đồ họa.',

  'parts.count.other': '${n} chi tiết',

  'side.title': 'Chi tiết mô hình',
  'common.share': 'Chia sẻ',
  'common.close': 'Đóng',
  'common.overview': 'Về tổng thể',
  'common.zoomSelected': 'Phóng đến chi tiết đang chọn',
  'author.editBadge': 'Chế độ chỉnh sửa',
  'author.lockedBadge': 'Đã khóa — không thể lưu',

  'ctx.open': 'Mở',
  'ctx.close': 'Đóng',
  'ctx.hide': 'Ẩn chi tiết',
  'ctx.isolate': 'Ẩn các chi tiết khác',

  'toast.locked': 'Mô hình đang bị khóa cập nhật',
  'toast.saved': 'Đã lưu thay đổi',
  'toast.badEditLink': 'Link chỉnh sửa không hợp lệ',
  'toast.saveFailed': 'Lưu thất bại — thử lại',
  'toast.copiedLink': 'Đã copy link',
  'toast.copiedEmbed': 'Đã copy mã nhúng',

  'tb.material': 'Vật liệu',
  'tb.matedge': 'Vật liệu + nét',
  'tb.wireframe': 'Khung dây',
  'tb.wireframeHidden': 'Khung dây + nét khuất',
  'tb.xray': 'X-ray',
  'tb.projection': 'Hình chiếu',
  'tb.viewIso': 'Phối cảnh',
  'tb.viewFront': 'Phía trước',
  'tb.viewLeft': 'Phía trái',
  'tb.viewRight': 'Phía phải',
  'tb.viewTop': 'Phía trên',
  'tb.fit': 'Vừa khung hình',
  'tb.openAll': 'Mở tất cả',
  'tb.closeAll': 'Đóng tất cả',
  'tb.fullscreen': 'Toàn màn hình',
  'tb.measure': 'Đo',
  'tb.lighting': 'Chiếu sáng',
  'tb.dimensions': 'Kích thước',
  'explode.title': 'Sơ đồ tách rời',
  'explode.amount': 'Mức tách rời',
  'list.selectGroup': 'Chọn cụm',
  'list.selectAll': 'Chọn tất cả cụm',
  'sel.count': 'Đã chọn ${n} cụm',
  'sel.part': 'Chi tiết đã chọn',
  'sel.hidden': 'Đang ẩn chi tiết',
  'sel.explode': 'Tách rời',
  'sel.hide': 'Ẩn cụm',
  'sel.hideOthers': 'Ẩn phần còn lại',
  'sel.labels': 'Nhãn sơ đồ',
  'sel.clear': 'Bỏ chọn',
  'tb.toolbar': 'Công cụ xem',
  'tb.modeGroup': 'Chế độ hiển thị',
  'tb.viewGroup': 'Góc nhìn',

  'list.search': 'Tìm chi tiết…',
  'list.scan': 'Quét mã chi tiết',
  'list.empty': 'Không tìm thấy chi tiết phù hợp.',
  'list.moduleOther': 'Khác',
  'list.codePrefix': 'CT ${code}',
  'list.toggleMotion': 'Mở / đóng',
  'list.show': 'Hiện chi tiết',
  'list.hide': 'Ẩn chi tiết',
  'list.showGroup': 'Hiện cả cụm',
  'list.hideGroup': 'Ẩn cả cụm',
  'list.showAll': 'Hiện lại toàn bộ',
  'list.collapse': 'Thu gọn cụm',
  'list.expand': 'Mở rộng cụm',
  'list.collapseAll': 'Thu gọn tất cả',
  'list.expandAll': 'Mở rộng tất cả',

  'info.selecting': 'Đang chọn',
  'info.code': 'Mã CT',
  'info.dims': 'Kích thước',
  'info.material': 'Vật liệu',
  'info.motion': 'Chuyển động',

  'motion.0': 'Cố định',
  'motion.2': 'Cửa bản lề phải',
  'motion.3': 'Cửa bản lề trái',
  'motion.4': 'Cửa lật xuống',
  'motion.5': 'Cửa nâng lên',
  'motion.6': 'Cửa trượt trái',
  'motion.7': 'Cửa trượt phải',
  'motion.8': 'Thân ngăn kéo',
  'motion.11': 'Mặt ngăn kéo',
  'motion.12': 'Aventos HS (nâng cung)',
  'motion.13': 'Piston (nâng thẳng)',
  'motion.14': 'Aventos HF (gập đôi)',
  'motion.15': 'Trượt sâu (Z)',

  'author.motionTitle': 'Cài đặt chuyển động',
  'author.lockedBanner': 'Model đã khóa cập nhật — không thể lưu',
  'author.selectPart': 'Chọn một chi tiết trên mô hình để gán cách mở.',
  'author.assigningTo': 'Đang gán cho:',
  'author.catDoor': 'Cửa',
  'author.catDrawer': 'Ngăn kéo',
  'author.catAdvanced': 'Nâng cao',
  'author.groupRel': 'Phối hợp chuyển động',
  'author.groupRelHint': 'Mặc định mỗi chi tiết mở riêng. Chỉ gộp khi muốn nhiều chi tiết mở cùng nhau (vd tay nắm + cánh, mặt + thân ngăn kéo).',
  'author.relIndependent': 'Mở riêng',
  'author.relIndependentSub': 'Chuyển động một mình',
  'author.relMergeWith': 'Mở cùng với',
  'author.groupShort': 'Nhóm',
  'author.catOptions': 'Tùy chọn',
  'author.mHingeL': 'Bản lề trái',
  'author.mHingeR': 'Bản lề phải',
  'author.mLiftDown': 'Lật xuống',
  'author.mLiftUp': 'Nâng lên',
  'author.mSlideL': 'Trượt trái',
  'author.mSlideR': 'Trượt phải',
  'author.mDrawerBody': 'Thân ngăn kéo',
  'author.mDrawerFront': 'Mặt ngăn kéo',
  'author.mAventosHS': 'Aventos HS',
  'author.mAventosHF': 'Tay nâng Blum',
  'author.mPiston': 'Piston',
  'author.mDeepSlide': 'Trượt sâu',
  'author.flip': 'Đảo chiều',
  'author.flipHint': 'Đổi cạnh bản lề (trái/phải).',
  'author.swingOut': 'Đổi chiều ra/vào',
  'author.swingOutHint': 'Cửa bật vào trong thân? Bấm để đảo chiều mở ra/vào (khác với bản lề trái/phải).',
  'author.clearAssign': 'Bỏ gán',
  'author.save': 'Lưu thay đổi',
  'author.saving': 'Đang lưu…',
  'author.lightTitle': 'Ánh sáng',
  'author.lightApplyAll': 'Áp cho tất cả người xem sau khi bấm “Lưu thay đổi”.',
  'author.lightOnState': 'Đang bật chiếu sáng',
  'author.lightOffState': 'Đang tắt — hiển thị phẳng',
  'author.lightOnHint': 'Bấm để TẮT hiệu ứng: mẫu hiện phẳng (đủ màu + vân) nhưng không đổ bóng, không loé sáng, không khối nổi — KHÔNG tối đi.',
  'author.lightOffHint': 'Bấm để BẬT lại: khôi phục khối nổi, bóng đổ và độ sáng theo kiểu đèn đang chọn.',
  'author.lightKind': 'Kiểu chiếu sáng',
  'author.lightEven': 'Chiếu đều',
  'author.lightStudio': 'Studio',
  'author.lightBright': 'Sáng hơn',
  'author.lightEvenHint': 'Ánh sáng đến từ nhiều phía nên không mặt nào bị tối; màu và vân dễ đọc ở mọi góc xoay, bóng nhẹ. Hợp để xem chi tiết.',
  'author.lightStudioHint': 'Bố trí 3 đèn tạo khối nổi, chiều sâu và bóng rõ, tương phản cao. Hợp để trình diễn / chụp sản phẩm.',
  'author.lightBrightHint': 'Tăng ánh sáng nền tổng thể, giảm vùng tối nên toàn mẫu sáng và đều hơn. Hợp khi vật liệu / màu sẫm khó nhìn.',
  'author.lightIntensity': 'Cường độ sáng',
  'author.lightIntensityHint': '50 = mức chuẩn của kiểu đang chọn · 100 = sáng gấp đôi · 0 = tối.',

  'measure.title': 'Đo kích thước',
  'measure.total': 'Tổng thể',
  'measure.inner': 'Lọt lòng',
  'measure.manual': 'Đo tay',
  'measure.clear': 'Xóa',
  'measure.manualHint': 'Bấm 2 điểm trên mô hình để đo khoảng cách.',
  'measure.innerHint': 'Bấm 2 tấm cùng phương — trên mô hình hoặc trong danh sách.',
  'measure.distance': 'Khoảng cách = ${mm} mm',
  'measure.point1': 'Đã chấm điểm 1 — bấm điểm thứ 2.',
  'measure.innerPick': 'Bấm tấm thứ ${n}',
  'measure.innerPick2': 'Bấm tấm thứ 2 song song (vách, kệ, cánh, hậu)',
  'measure.innerSameDir': 'Hãy chọn 2 tấm song song (cùng phương)',
  'measure.innerResult': 'Lọt lòng = ${mm} mm',
  'measure.innerGapResult': 'Khe = ${mm} mm',
  'measure.innerOverlap': '2 tấm chồng lên nhau — không có khoảng hở để đo',
  'measure.innerNoDir': 'Không xác định được phương tấm (tấm uốn hoặc đặt xiên)',
  'measure.innerRotateHint': '↻ Xoay góc nhìn để thấy đường đo',

  'hints.title': 'Mẹo thao tác',
  'hints.rotate': '1 ngón: xoay mô hình',
  'hints.pan': '2 ngón: di chuyển & phóng to/thu nhỏ',
  'hints.dblTap': 'Chạm 2 lần: mở/đóng cánh tủ & ngăn kéo',
  'hints.ok': 'Đã hiểu',

  'scan.title': 'Quét mã chi tiết',
  'scan.opening': 'Đang mở camera…',
  'scan.aim': 'Đưa mã QR của chi tiết vào khung',
  'scan.zoom': 'Phóng to tem',
  'scan.badFormat': 'Mã "${text}" không đúng định dạng. Hãy quét mã khác.',
  'scan.notFound': 'Không tìm thấy chi tiết khớp mã "${text}".',
  'scan.noSupport': 'Trình duyệt không hỗ trợ camera (cần HTTPS hoặc localhost).',
  'scan.noAccess': 'Không truy cập được camera. Hãy cấp quyền camera (cần HTTPS hoặc localhost) rồi thử lại.',

  'share.title': 'Chia sẻ mô hình',
  'share.qrFallback': 'Mã QR cần kết nối máy chủ',
  'share.copyLink': 'Sao chép link',
  'share.embedLabel': 'Mã nhúng (iframe)',
  'share.copyEmbed': 'Sao chép mã nhúng',

  'lang.label': 'Ngôn ngữ',

  // ----- AI Render (04a) -----
  'airender.title': 'Diễn hoạ AI',
  'airender.open': 'Diễn hoạ AI ✨',
  'airender.generate': 'Tạo ảnh',
  'airender.generating': 'Đang tạo…',
  'airender.fieldRenderType': 'Loại diễn hoạ',
  'airender.fieldLighting': 'Ánh sáng',
  'airender.fieldViewAngle': 'Góc nhìn',
  'airender.fieldEnvironment': 'Môi trường',
  'airender.fieldColorTone': 'Tông màu',
  'airender.fieldAspect': 'Tỉ lệ',
  'airender.fieldModel': 'Model AI',
  'airender.fieldDescription': 'Mô tả',
  'airender.fieldCreativity': 'Độ sáng tạo',
  'airender.descPlaceholder': 'Mô tả thêm về khung cảnh mong muốn…',
  'airender.fieldMaterials': 'Vật liệu',
  'airender.fieldNegative': 'Loại trừ (negative)',
  'airender.negativePlaceholder': 'Vật thể không mong muốn, biến dạng…',
  'airender.fieldEnvironmentText': 'Môi trường khác',
  'airender.fieldLightingText': 'Ánh sáng khác',
  'airender.lightingTextPlaceholder': 'Mô tả ánh sáng riêng…',
  'airender.fieldSize': 'Kích thước',
  'airender.sizeNote': 'Kích thước = độ phân giải ảnh chụp nền; tỉ lệ khung quyết định ảnh AI xuất ra.',
  'airender.opt.size.1024x1024': 'Vuông (1024×1024)',
  'airender.opt.size.1080x1080': 'Vuông MXH (1080×1080)',
  'airender.opt.size.1536x1024': 'Ngang (1536×1024)',
  'airender.opt.size.1024x1536': 'Dọc (1024×1536)',
  'airender.opt.size.1920x1080': 'Full HD ngang (1920×1080)',
  'airender.opt.size.1080x1920': 'Full HD dọc (1080×1920)',
  'airender.opt.size.1280x720': 'HD ngang (1280×720)',
  'airender.opt.size.2048x2048': 'Vuông lớn (2048×2048)',
  // v3 (10e/04f): 2 thang sáng tạo + tự tạo không gian phòng
  'airender.fieldLockGeometry': 'Giữ nguyên mô hình 3D',
  'airender.lockOnHint':
    'Khóa chặt hình khối theo mô hình 3D (gửi kèm ảnh cấu trúc) — AI chỉ đổi vật liệu/bối cảnh, không đổi hình dáng.',
  'airender.lockOffHint': 'Cho phép AI sáng tạo lại hình khối (chế độ cũ, dùng thanh "giữ thiết kế").',
  'airender.fieldPreserveFurniture': 'Mức độ giữ nguyên thiết kế 3D',
  'airender.fieldContextCreativity': 'Mức độ sáng tạo bối cảnh',
  'airender.creativityNote':
    '"Mức độ giữ nguyên thiết kế 3D" cao = bám sát hình học/tỉ lệ mô hình gốc; "Mức độ sáng tạo bối cảnh" cao = phòng/bối cảnh tỉ mỉ hơn.',
  'airender.roomSection': 'Tự tạo không gian phòng',
  'airender.fieldRoomSource': 'Nguồn phòng',
  'airender.fieldWall': 'Tường',
  'airender.fieldFloor': 'Sàn',
  'airender.fieldCeiling': 'Trần',
  'airender.fieldBacksplash': 'Backsplash',
  'airender.fieldIsland': 'Bàn đảo',
  'airender.fieldAccessory': 'Decor',
  'airender.roomNote': 'Phần này chỉ dùng cho Nội thất.',
  'airender.opt.roomSource.ai-generated': 'AI tạo phòng mới',
  'airender.opt.roomSource.use-existing': 'Dùng phòng sẵn trong model',
  'airender.opt.wall.auto': 'Tự động',
  'airender.opt.wall.light-warm': 'Sáng ấm',
  'airender.opt.wall.matte-white': 'Trắng mờ',
  'airender.opt.wall.soft-concrete': 'Bê tông nhẹ',
  'airender.opt.wall.marble-accent': 'Điểm nhấn cẩm thạch',
  'airender.opt.wall.wood-accent': 'Điểm nhấn gỗ',
  'airender.opt.floor.auto': 'Tự động',
  'airender.opt.floor.light-tiles': 'Gạch sáng',
  'airender.opt.floor.warm-wood': 'Gỗ ấm',
  'airender.opt.floor.light-stone': 'Đá sáng',
  'airender.opt.floor.matte-concrete': 'Bê tông mờ',
  'airender.opt.ceiling.auto': 'Tự động',
  'airender.opt.ceiling.recessed-spotlights': 'Đèn âm trần',
  'airender.opt.ceiling.linear-led': 'LED thanh',
  'airender.opt.ceiling.pendant-island': 'Đèn thả bàn đảo',
  'airender.opt.ceiling.minimal-flat': 'Phẳng tối giản',
  'airender.opt.backsplash.auto': 'Tự động',
  'airender.opt.backsplash.light-stone': 'Đá sáng',
  'airender.opt.backsplash.white-tile': 'Gạch trắng',
  'airender.opt.backsplash.marble-slab': 'Tấm cẩm thạch',
  'airender.opt.backsplash.warm-gray': 'Xám ấm',
  'airender.opt.backsplash.none': 'Không',
  'airender.opt.island.none': 'Không',
  'airender.opt.island.one': 'Một bàn đảo',
  'airender.opt.island.auto': 'Tự động',
  'airender.opt.accessory.none': 'Không',
  'airender.opt.accessory.low': 'Ít',
  'airender.opt.accessory.medium': 'Vừa',
  'airender.opt.accessory.high': 'Nhiều',
  'airender.environmentTextPlaceholder': 'Mô tả môi trường mong muốn…',
  'airender.noModels': 'Chưa có model AI khả dụng',
  'airender.modelNoKey': 'chưa có khóa',
  'airender.noKey': 'Bạn chưa nhập khóa API cho nhà cung cấp này.',
  'airender.openConsole': 'Mở Console',
  'airender.viewAngleNote': 'Góc nhìn do AI diễn lại trong ảnh — không xoay mô hình 3D.',
  'airender.statusQueued': 'Đang xếp hàng…',
  'airender.statusRunning': 'Đang diễn hoạ…',
  'airender.failed': 'Tạo ảnh thất bại',
  'airender.errGeneric': 'Có lỗi xảy ra — thử lại',
  'airender.errCap': 'Đã đạt số ảnh tối đa cho mô hình này',
  'airender.errQuota': 'Vượt dung lượng tài khoản',
  'airender.resultHint': 'Đặt khung cảnh rồi bấm "Tạo ảnh" để diễn hoạ.',
  'airender.savedCount': 'Đã lưu: ${n}',
  'airender.save': 'Lưu',
  'airender.savedBadge': 'Đã lưu',
  'airender.download': 'Tải xuống',
  'airender.setThumbnail': 'Đặt làm ảnh đại diện',
  'airender.delete': 'Xóa',
  'airender.toastSaved': 'Đã lưu ảnh render',
  'airender.toastDeleted': 'Đã xóa ảnh render',
  'airender.toastThumbnail': 'Đã đặt làm ảnh đại diện',
  'airender.galleryBtn': 'Ảnh render',
  'airender.galleryTitle': 'Ảnh render',
  'airender.galleryEmpty': 'Chưa có ảnh render nào được lưu.',
  'airender.prevImage': 'Ảnh trước',
  'airender.nextImage': 'Ảnh sau',
  'airender.opt.renderType.architecture': 'Kiến trúc',
  'airender.opt.renderType.landscape': 'Cảnh quan',
  'airender.opt.renderType.interior': 'Nội thất',
  'airender.opt.lighting.overcast': 'U ám',
  'airender.opt.lighting.natural': 'Tự nhiên',
  'airender.opt.lighting.sunny': 'Có nắng',
  'airender.opt.lighting.interior-lights': 'Đèn Nội thất',
  'airender.opt.lighting.evening-interior': 'Chiều tối (Nội thất)',
  'airender.opt.lighting.dark-interior': 'Tối - Đen (Nội thất)',
  'airender.opt.lighting.studio': 'Phòng thu',
  'airender.opt.lighting.dappled-interior': 'Hoa Nắng (Nội thất)',
  'airender.opt.lighting.golden-hour': 'Giờ vàng',
  'airender.opt.lighting.indirect-led': 'LED Gián tiếp',
  'airender.opt.lighting.other': 'Khác',
  'airender.opt.viewAngle.keep': 'Giữ nguyên',
  'airender.opt.viewAngle.front': 'Chính diện',
  'airender.opt.viewAngle.wide': 'Góc rộng',
  'airender.opt.viewAngle.drone': 'Từ trên cao (drone)',
  'airender.opt.viewAngle.three-quarter-left': '3/4 bên trái',
  'airender.opt.viewAngle.three-quarter-right': '3/4 bên phải',
  'airender.opt.viewAngle.low': 'Góc thấp',
  'airender.opt.viewAngle.high': 'Góc cao',
  'airender.opt.environment.urban': 'Đô thị',
  'airender.opt.environment.street': 'Đường phố',
  'airender.opt.environment.village': 'Làng quê',
  'airender.opt.environment.countryside': 'Vùng quê',
  'airender.opt.environment.living-room': 'Phòng khách',
  'airender.opt.environment.bedroom': 'Phòng ngủ',
  'airender.opt.environment.kitchen': 'Nhà bếp',
  'airender.opt.colorTone.natural': 'Tự nhiên',
  'airender.opt.colorTone.warm': 'Ấm áp',
  'airender.opt.colorTone.cool-modern': 'Lạnh hiện đại',
  'airender.opt.colorTone.bw': 'Đen Trắng',
  'airender.opt.colorTone.vintage-retro': 'Vintage-Retro',
  'airender.opt.colorTone.pastel': 'Pastel',
  'airender.opt.colorTone.cinematic': 'Điện ảnh',
  'airender.opt.colorTone.modern-warm': 'Hiện đại ấm áp',
  'airender.opt.colorTone.luxury': 'Luxury cao cấp',
  'airender.opt.colorTone.japandi': 'Japandi tối giản',
  'airender.opt.colorTone.premium-apartment': 'Căn hộ cao cấp',
  'airender.opt.colorTone.kitchen-showroom': 'Showroom bếp',
  'airender.opt.colorTone.scandinavian': 'Scandinavian sáng nhẹ',
  // Nhãn tier model AI (04h)
  'airender.opt.quality.very-high': 'Chất lượng rất cao',
  'airender.opt.quality.high': 'Chất lượng cao',
  'airender.opt.quality.fair': 'Chất lượng khá',
  'airender.opt.price.very-expensive': 'Giá rất đắt',
  'airender.opt.price.expensive': 'Giá đắt',
  'airender.opt.price.medium': 'Giá trung bình',
  'airender.opt.price.cheap': 'Giá rẻ',
  'airender.opt.speed.fast': 'Tốc độ nhanh',
  'airender.opt.speed.medium': 'Tốc độ trung bình',
  'airender.opt.speed.slow': 'Tốc độ chậm',
  'airender.opt.modelTag.new': 'mới',
  // Gợi ý nhập liệu + ví dụ mẫu (04h)
  'airender.fillExample': 'Điền mẫu tự động',
  // Bối cảnh ngoại cảnh (10f/04g)
  'airender.archSection': 'Bối cảnh Kiến trúc',
  'airender.landSection': 'Bối cảnh Cảnh quan',
  'airender.fieldScene': 'Cảnh',
  'airender.fieldArchSurrounding': 'Công trình xung quanh',
  'airender.fieldArchActivity': 'Mức hoạt động (người/xe)',
  'airender.fieldArchGround': 'Mặt nền',
  'airender.fieldSky': 'Bầu trời',
  'airender.fieldLandTerrain': 'Địa hình',
  'airender.fieldLandWater': 'Yếu tố nước',
  'airender.fieldLandHeroTree': 'Cây chủ đạo',
  'airender.fieldLandGround': 'Mặt đất',
  'airender.sceneVsEnvNote': 'Khi chọn "Cảnh" bên dưới (≠ Tự động), nó thay cho "Môi trường". "Môi trường" chỉ dùng khi để "Cảnh" = Tự động, hoặc chọn "Khác" để mô tả tự do.',
  'airender.opt.archScene.auto': 'Tự động',
  'airender.opt.archScene.urban-heritage-street': 'Phố cổ đô thị',
  'airender.opt.archScene.old-town': 'Khu phố cũ',
  'airender.opt.archScene.modern-city': 'Thành phố hiện đại',
  'airender.opt.archScene.tourist-street': 'Phố du lịch',
  'airender.opt.archScene.garden-courtyard': 'Sân vườn',
  'airender.opt.archSurrounding.auto': 'Tự động',
  'airender.opt.archSurrounding.low-rise-nearby': 'Nhà thấp tầng gần',
  'airender.opt.archSurrounding.high-rise-far': 'Cao tầng phía xa',
  'airender.opt.archSurrounding.mixed': 'Hỗn hợp',
  'airender.opt.archSurrounding.none': 'Không có',
  'airender.opt.archActivity.auto': 'Tự động',
  'airender.opt.archActivity.none': 'Không có',
  'airender.opt.archActivity.light': 'Thưa',
  'airender.opt.archActivity.medium': 'Vừa',
  'airender.opt.archActivity.busy': 'Đông đúc',
  'airender.opt.archGround.auto': 'Tự động',
  'airender.opt.archGround.stone-pavement': 'Lát đá',
  'airender.opt.archGround.sidewalk': 'Vỉa hè',
  'airender.opt.archGround.asphalt': 'Nhựa đường',
  'airender.opt.sky.auto': 'Tự động',
  'airender.opt.sky.golden-hour': 'Giờ vàng',
  'airender.opt.sky.daylight': 'Ban ngày',
  'airender.opt.sky.clear': 'Trời quang',
  'airender.opt.sky.overcast': 'U ám',
  'airender.opt.sky.night': 'Ban đêm',
  'airender.opt.landScene.auto': 'Tự động',
  'airender.opt.landScene.forest': 'Rừng cây',
  'airender.opt.landScene.streamside': 'Ven suối',
  'airender.opt.landScene.mountain': 'Vùng núi',
  'airender.opt.landScene.japanese-garden': 'Vườn Nhật',
  'airender.opt.landScene.park': 'Công viên',
  'airender.opt.landScene.old-village': 'Làng cổ',
  'airender.opt.landScene.lakeside': 'Ven hồ',
  'airender.opt.landTerrain.auto': 'Tự động',
  'airender.opt.landTerrain.forest-clearing': 'Khoảng trống trong rừng',
  'airender.opt.landTerrain.gentle-hill': 'Đồi thoải',
  'airender.opt.landTerrain.streamside': 'Ven suối',
  'airender.opt.landTerrain.rocky': 'Nhiều đá',
  'airender.opt.landTerrain.paved-path': 'Lối đi lát đá',
  'airender.opt.landWater.auto': 'Tự động',
  'airender.opt.landWater.none': 'Không có',
  'airender.opt.landWater.stream-beside': 'Suối bên cạnh',
  'airender.opt.landWater.stream-front': 'Suối phía trước',
  'airender.opt.landWater.pond-front': 'Ao/hồ phía trước',
  'airender.opt.landWater.waterfall-back': 'Thác phía sau',
  'airender.opt.landHeroTree.auto': 'Tự động',
  'airender.opt.landHeroTree.none': 'Không có',
  'airender.opt.landHeroTree.ancient-pine-behind': 'Tùng cổ phía sau',
  'airender.opt.landHeroTree.red-maple': 'Phong đỏ',
  'airender.opt.landHeroTree.bamboo': 'Tre trúc',
  'airender.opt.landHeroTree.natural-forest': 'Rừng tự nhiên',
  'airender.opt.landGround.auto': 'Tự động',
  'airender.opt.landGround.stone-and-moss': 'Đá và rêu',
  'airender.opt.landGround.grass': 'Thảm cỏ',
  'airender.opt.landGround.dirt': 'Nền đất',
  'airender.hint.renderType': 'Chọn loại ảnh muốn tạo: nội thất trong phòng, công trình kiến trúc, hay cảnh quan ngoài trời.',
  'airender.hint.environment': 'Bối cảnh/loại phòng quanh sản phẩm (vd phòng khách, đường phố). Chọn "Khác" để tự nhập.',
  'airender.hint.lighting': 'Kiểu ánh sáng cho ảnh — chọn 0 hoặc nhiều mục; để trống = AI tự quyết.',
  'airender.hint.colorTone': 'Tông màu/phong cách màu tổng thể — chọn 0 hoặc nhiều; để trống = AI tự quyết.',
  'airender.hint.materials': 'Vật liệu muốn nhấn trong ảnh — chọn nhiều; "Giữ nguyên" = bám vật liệu gốc.',
  'airender.hint.model': 'Chọn model AI dùng để diễn hoạ (theo nhà cung cấp bạn đã nhập khóa).',
  'airender.hint.negative': 'Liệt kê những thứ KHÔNG muốn xuất hiện (vd: người, chữ, biến dạng).',
  'airender.hint.desc.interior': 'Hãy mô tả loại phòng, cách đồ nội thất gắn với tường/sàn/trần, thiết bị cần thêm, vật trang trí, cảm giác không gian và các chi tiết bắt buộc phải giữ.',
  'airender.hint.desc.architecture': 'Hãy mô tả công trình, bối cảnh xung quanh, hoạt động trong cảnh, vật liệu chủ đạo và những chi tiết không được làm mất thiết kế gốc.',
  'airender.hint.desc.landscape': 'Hãy mô tả địa hình, cây cối, nước, đá, nền đất, hậu cảnh và vị trí của chủ thể trong cảnh. Nên nói rõ yếu tố nào nằm phía trước, bên cạnh hoặc phía sau chủ thể.',
  'airender.ex.interior.1': 'Không gian bếp mở hiện đại, ngập tràn ánh sáng tự nhiên từ vách kính lớn. Hệ tủ gỗ được lắp ráp hoàn hảo sát tường, mặt bàn ốp đá thạch anh vân mây. Có máy hút mùi. Trên mặt bếp có điểm xuyết một chậu cây xanh nhỏ, giỏ hoa quả tươi và một máy pha cà phê espresso, một máy KitchenAid. Chậu cây trầu bà lá xẻ to, đẹp ở cạnh tủ lạnh. Có một bà nội trợ người Việt Nam đang nhìn món ăn. Có một em bé Việt Nam đang bám chân mẹ. Trên bàn đảo có mâm đồ ăn ngon, thịnh soạn.',
  'airender.ex.interior.2': 'Tủ bếp được lắp cố định vào hai bức tường vuông góc của phòng bếp. Trong tủ có máy hút mùi, lò nướng và lò vi sóng âm tủ. Trên mặt bàn có bếp từ, một cây cảnh nhỏ và máy KitchenAid. Ở giữa phòng có một bàn đảo bếp đồng bộ với mặt đá. Không gian cần ấm áp, sạch sẽ, cao cấp và không bị quá nhiều đồ trang trí.',
  'airender.ex.interior.3': 'Kệ TV được lắp sát tường chính của phòng khách. Xung quanh có tường sáng màu, sàn gỗ ấm, sofa thấp phía trước và một bàn trà nhỏ. Trên kệ có một vài đồ decor nhẹ, cây xanh nhỏ và ánh sáng hắt tường. Không gian cần hiện đại, gọn gàng, sang trọng và giữ nguyên thiết kế kệ gốc.',
  'airender.ex.interior.4': 'Tủ áo được đặt sát tường trong phòng ngủ, bên cạnh có bàn trang điểm nhỏ và gương. Phòng có giường thấp, rèm sáng màu, sàn gỗ và ánh sáng vàng nhẹ. Không gian cần ấm áp, thư giãn, sạch sẽ và cao cấp. Cần giữ nguyên bố cục, tỉ lệ và vật liệu chính của hệ tủ.',
  'airender.ex.landscape.1': 'Công trình chòi nghỉ bằng gỗ truyền thống đặt giữa một khu vườn sinh thái nhiệt đới xanh mát. Công trình nằm vững chãi trên nền đất rải sỏi và các khối đá tảng tự nhiên, bao quanh là các bụi dương xỉ và rêu phong. Bên cạnh có một dòng suối nhỏ chảy róc rách. Ánh nắng vàng rực rỡ của buổi hoàng hôn chiếu xuyên qua kẽ lá, đổ bóng mềm mại xuống mái ngói.',
  'airender.ex.landscape.2': 'Ngôi chùa gỗ nằm trong một khoảng rừng yên tĩnh. Bên cạnh chùa có một con suối nhỏ chảy qua, phía trước có đá tự nhiên và rêu xanh. Phía sau chùa là một cây tùng cổ thụ lớn, xung quanh có rừng cây xanh dày nhưng không che mất công trình. Không khí thanh bình, tự nhiên và có chiều sâu.',
  'airender.ex.landscape.3': 'Công trình pavilion nằm giữa công viên rộng. Xung quanh có thảm cỏ, lối đi lát đá, cây xanh thấp và vài cây lớn ở hậu cảnh. Phía trước có khoảng sân mở để nhìn rõ toàn bộ công trình. Cảnh quan cần sáng, thoáng, tự nhiên và phù hợp cho ảnh giới thiệu kiến trúc ngoài trời.',
  'airender.ex.landscape.4': 'Công trình nằm trên một triền đồi thoải, nhìn ra thung lũng xanh phía xa. Xung quanh có cỏ, đá tự nhiên, bụi cây thấp và một vài cây lớn. Hậu cảnh có núi mờ nhẹ và bầu trời trong. Chủ thể cần nổi bật, không bị cây cối che khuất.',
  'airender.ex.architecture.1': 'Gian hàng gỗ mang phong cách Á Đông truyền thống nằm nổi bật trên một con phố đi bộ lát đá nhộn nhịp. Xung quanh là các dãy nhà phố hiện đại với ánh đèn đường mờ ảo phía xa. Bầu không khí chạng vạng tối. Ánh sáng vàng dịu nhẹ từ các bóng đèn LED âm trần hắt xuống mặt đường, tạo nên sự giao thoa hoàn hảo giữa nét kiến trúc cổ điển và nhịp sống đô thị.',
  'airender.ex.architecture.2': 'Quán cafe phong cách cổ trang nằm ở góc một khu phố đông người. Gần quán có vài nhà thấp tầng, phía xa là các khối nhà cao tầng hiện đại. Trước quán có vỉa hè lát đá, vài người đi bộ và xe cộ ở phía sau, nhưng không che mặt tiền quán. Công trình cần giữ rõ mái cong, kết cấu gỗ, các khung kính và khu vực quầy phía trước.',
  'airender.ex.architecture.3': 'Showroom nội thất nằm trên một tuyến phố hiện đại. Mặt tiền quay ra đường lớn, phía trước có vỉa hè rộng, cây xanh đô thị và một vài xe đỗ bên đường. Hai bên là các công trình thấp tầng hiện đại. Không gian cần sạch sẽ, cao cấp, phù hợp để làm ảnh giới thiệu thương mại.',
  'airender.ex.architecture.4': 'Công trình nhà gỗ nghỉ dưỡng nằm ven hồ, xung quanh có cây xanh, lối đi lát đá và sân nhỏ phía trước. Phía sau là rừng cây nhẹ và mặt nước phản chiếu ánh sáng. Cần giữ nguyên hình khối kiến trúc, mái, vật liệu gỗ và tỉ lệ công trình gốc.',
  'airender.opt.environment.other': 'Khác',
  'airender.opt.material.keep': 'Giữ nguyên như ảnh gốc',
  'airender.opt.material.wood': 'Gỗ',
  'airender.opt.material.glass': 'Kính',
  'airender.opt.material.stone': 'Đá',
  'airender.opt.material.brick': 'Gạch',
  'airender.opt.material.marble': 'Cẩm thạch',
  'airender.opt.material.aluminum-glass': 'Nhôm kính',
  'airender.opt.material.ceramic': 'Gốm sứ',
  'airender.opt.material.bamboo-rattan': 'Tre - Mây',
  'airender.opt.material.composite-panel': 'Tấm ốp Composite',
  'airender.opt.material.laterite': 'Đá ong',
  'airender.opt.material.concrete': 'Bê tông',
};

const en: Dict = {
  'app.loading': 'Loading model…',
  'app.noToken': 'No model code found in the link.',
  'app.retry': 'Retry',
  'err.private.title': 'Private model',
  'err.private.body': 'This model is private. You need an Author link from the owner to view it.',
  'err.notfound.title': 'Model not found',
  'err.notfound.body': 'The link does not exist or has expired. Please check the link with the sender.',
  'err.version.title': 'Viewer update needed',
  'err.version.body': 'The model uses a newer format than this viewer. Please try again later.',
  'err.empty.title': 'Empty model',
  'err.empty.body': 'This model has no parts to display.',
  'err.network.title': 'Could not load model',
  'err.network.body': 'A connection error occurred. Please check your network and try again.',
  'err.webgl.title': 'Cannot display the 3D model',
  'err.webgl.body':
    'Hardware acceleration (WebGL) is not enabled in your browser on this machine. Turn on "Use hardware acceleration" in your browser settings and restart it, update your graphics driver, or try a different browser. If you are on Remote Desktop or a virtual machine, open the link directly on a device with a graphics card.',

  'parts.count.one': '${n} part',
  'parts.count.other': '${n} parts',

  'side.title': 'Model parts',
  'common.share': 'Share',
  'common.close': 'Close',
  'common.overview': 'Overview',
  'common.zoomSelected': 'Zoom to selected part',
  'author.editBadge': 'Edit mode',
  'author.lockedBadge': 'Locked — cannot save',

  'ctx.open': 'Open',
  'ctx.close': 'Close',
  'ctx.hide': 'Hide part',
  'ctx.isolate': 'Hide other parts',

  'toast.locked': 'The model is locked from updates',
  'toast.saved': 'Changes saved',
  'toast.badEditLink': 'Invalid edit link',
  'toast.saveFailed': 'Save failed — try again',
  'toast.copiedLink': 'Link copied',
  'toast.copiedEmbed': 'Embed code copied',

  'tb.material': 'Material',
  'tb.matedge': 'Material with edges',
  'tb.wireframe': 'Wireframe',
  'tb.wireframeHidden': 'Wireframe + hidden lines',
  'tb.xray': 'X-ray',
  'tb.projection': 'Projection',
  'tb.viewIso': 'Perspective',
  'tb.viewFront': 'Front',
  'tb.viewLeft': 'Left',
  'tb.viewRight': 'Right',
  'tb.viewTop': 'Top',
  'tb.fit': 'Fit to view',
  'tb.openAll': 'Open all',
  'tb.closeAll': 'Close all',
  'tb.fullscreen': 'Fullscreen',
  'tb.measure': 'Measure',
  'tb.lighting': 'Lighting',
  'tb.dimensions': 'Dimensions',
  'explode.title': 'Exploded view',
  'explode.amount': 'Separation',
  'list.selectGroup': 'Select group',
  'list.selectAll': 'Select all groups',
  'sel.count': '${n} group(s) selected',
  'sel.part': 'Selected part',
  'sel.hidden': 'Parts hidden',
  'sel.explode': 'Explode',
  'sel.hide': 'Hide group',
  'sel.hideOthers': 'Hide others',
  'sel.labels': 'Labels',
  'sel.clear': 'Clear',
  'tb.toolbar': 'Viewer tools',
  'tb.modeGroup': 'Display mode',
  'tb.viewGroup': 'View',

  'list.search': 'Search parts…',
  'list.scan': 'Scan part code',
  'list.empty': 'No matching parts found.',
  'list.moduleOther': 'Other',
  'list.codePrefix': 'No. ${code}',
  'list.toggleMotion': 'Open / close',
  'list.show': 'Show part',
  'list.hide': 'Hide part',
  'list.showGroup': 'Show group',
  'list.hideGroup': 'Hide group',
  'list.showAll': 'Show all',
  'list.collapse': 'Collapse group',
  'list.expand': 'Expand group',
  'list.collapseAll': 'Collapse all',
  'list.expandAll': 'Expand all',

  'info.selecting': 'Selected',
  'info.code': 'Part no.',
  'info.dims': 'Dimensions',
  'info.material': 'Material',
  'info.motion': 'Motion',

  'motion.0': 'Fixed',
  'motion.2': 'Right-hinged door',
  'motion.3': 'Left-hinged door',
  'motion.4': 'Flap-down door',
  'motion.5': 'Lift-up door',
  'motion.6': 'Left sliding door',
  'motion.7': 'Right sliding door',
  'motion.8': 'Drawer box',
  'motion.11': 'Drawer front',
  'motion.12': 'Aventos HS (arc lift)',
  'motion.13': 'Piston (straight lift)',
  'motion.14': 'Aventos HF (bi-fold)',
  'motion.15': 'Deep slide (Z)',

  'author.motionTitle': 'Motion settings',
  'author.lockedBanner': 'Model is locked from updates — cannot save',
  'author.selectPart': 'Select a part on the model to assign how it opens.',
  'author.assigningTo': 'Assigning to:',
  'author.catDoor': 'Door',
  'author.catDrawer': 'Drawer',
  'author.catAdvanced': 'Advanced',
  'author.groupRel': 'Movement coordination',
  'author.groupRelHint': 'By default each part moves on its own. Merge only when several parts should move together (e.g. handle + door, drawer front + body).',
  'author.relIndependent': 'Moves on its own',
  'author.relIndependentSub': 'Independent movement',
  'author.relMergeWith': 'Moves with',
  'author.groupShort': 'Group',
  'author.catOptions': 'Options',
  'author.mHingeL': 'Left hinge',
  'author.mHingeR': 'Right hinge',
  'author.mLiftDown': 'Flap down',
  'author.mLiftUp': 'Lift up',
  'author.mSlideL': 'Slide left',
  'author.mSlideR': 'Slide right',
  'author.mDrawerBody': 'Drawer box',
  'author.mDrawerFront': 'Drawer front',
  'author.mAventosHS': 'Aventos HS',
  'author.mAventosHF': 'Blum lift',
  'author.mPiston': 'Piston',
  'author.mDeepSlide': 'Deep slide',
  'author.flip': 'Flip',
  'author.flipHint': 'Swap hinge side (left/right).',
  'author.swingOut': 'Swing in/out',
  'author.swingOutHint': 'Door swinging into the body? Toggle open in/out direction (separate from left/right hinge).',
  'author.clearAssign': 'Clear',
  'author.save': 'Save changes',
  'author.saving': 'Saving…',
  'author.lightTitle': 'Lighting',
  'author.lightApplyAll': 'Applies to all viewers after you click “Save changes”.',
  'author.lightOnState': 'Lighting on',
  'author.lightOffState': 'Off — flat display',
  'author.lightOnHint': 'Click to TURN OFF effects: the model shows flat (full colour + grain) but with no shadows, highlights or depth — it does NOT go dark.',
  'author.lightOffHint': 'Click to TURN ON: restore depth, shadows and brightness per the chosen lighting.',
  'author.lightKind': 'Lighting style',
  'author.lightEven': 'Even',
  'author.lightStudio': 'Studio',
  'author.lightBright': 'Brighter',
  'author.lightEvenHint': 'Light comes from many sides so no face stays dark; colour and grain read well at any angle, with soft shadows. Good for inspecting details.',
  'author.lightStudioHint': '3-point setup gives depth, relief and clear shadows with high contrast. Good for presenting / shooting the product.',
  'author.lightBrightHint': 'Raises overall ambient light and reduces dark areas so the whole model is brighter and more even. Good for dark materials / colours.',
  'author.lightIntensity': 'Brightness',
  'author.lightIntensityHint': '50 = standard for the chosen style · 100 = twice as bright · 0 = dark.',

  'measure.title': 'Measure',
  'measure.total': 'Overall',
  'measure.inner': 'Inner',
  'measure.manual': 'Manual',
  'measure.clear': 'Clear',
  'measure.manualHint': 'Click 2 points on the model to measure the distance.',
  'measure.innerHint': 'Click 2 parallel panels — on the model or in the list.',
  'measure.distance': 'Distance = ${mm} mm',
  'measure.point1': 'Point 1 set — click the 2nd point.',
  'measure.innerPick': 'Click panel ${n}',
  'measure.innerPick2': 'Click the 2nd parallel panel (side, shelf, door, back)',
  'measure.innerSameDir': 'Please pick 2 parallel panels',
  'measure.innerResult': 'Inner = ${mm} mm',
  'measure.innerGapResult': 'Gap = ${mm} mm',
  'measure.innerOverlap': 'The 2 panels overlap — no gap to measure',
  'measure.innerNoDir': 'Cannot determine panel direction (bent or slanted panel)',
  'measure.innerRotateHint': '↻ Rotate the view to see the dimension',

  'hints.title': 'Gesture tips',
  'hints.rotate': '1 finger: rotate the model',
  'hints.pan': '2 fingers: pan & zoom',
  'hints.dblTap': 'Double-tap: open/close doors & drawers',
  'hints.ok': 'Got it',

  'scan.title': 'Scan part code',
  'scan.opening': 'Opening camera…',
  'scan.aim': 'Point the part’s QR code into the frame',
  'scan.zoom': 'Zoom into label',
  'scan.badFormat': 'Code "${text}" has the wrong format. Please scan another code.',
  'scan.notFound': 'No part matches code "${text}".',
  'scan.noSupport': 'Browser does not support the camera (needs HTTPS or localhost).',
  'scan.noAccess': 'Could not access the camera. Please grant camera permission (needs HTTPS or localhost) and try again.',

  'share.title': 'Share model',
  'share.qrFallback': 'QR code needs a server connection',
  'share.copyLink': 'Copy link',
  'share.embedLabel': 'Embed code (iframe)',
  'share.copyEmbed': 'Copy embed code',

  'lang.label': 'Language',

  // ----- AI Render (04a) -----
  'airender.title': 'AI Render',
  'airender.open': 'AI Render ✨',
  'airender.generate': 'Generate',
  'airender.generating': 'Generating…',
  'airender.fieldRenderType': 'Render type',
  'airender.fieldLighting': 'Lighting',
  'airender.fieldViewAngle': 'View angle',
  'airender.fieldEnvironment': 'Environment',
  'airender.fieldColorTone': 'Color tone',
  'airender.fieldAspect': 'Aspect ratio',
  'airender.fieldModel': 'AI model',
  'airender.fieldDescription': 'Description',
  'airender.fieldCreativity': 'Creativity',
  'airender.descPlaceholder': 'Add details about the scene you want…',
  'airender.fieldMaterials': 'Materials',
  'airender.fieldNegative': 'Negative prompt',
  'airender.negativePlaceholder': 'Unwanted objects, distortion…',
  'airender.fieldEnvironmentText': 'Other environment',
  'airender.fieldLightingText': 'Other lighting',
  'airender.lightingTextPlaceholder': 'Describe custom lighting…',
  'airender.fieldSize': 'Size',
  'airender.sizeNote': 'Size = resolution of the captured base image; the frame ratio drives the AI output.',
  'airender.opt.size.1024x1024': 'Square (1024×1024)',
  'airender.opt.size.1080x1080': 'Square social (1080×1080)',
  'airender.opt.size.1536x1024': 'Landscape (1536×1024)',
  'airender.opt.size.1024x1536': 'Portrait (1024×1536)',
  'airender.opt.size.1920x1080': 'Full HD landscape (1920×1080)',
  'airender.opt.size.1080x1920': 'Full HD portrait (1080×1920)',
  'airender.opt.size.1280x720': 'HD landscape (1280×720)',
  'airender.opt.size.2048x2048': 'Large square (2048×2048)',
  // v3 (10e/04f): two creativity scales + auto-generate room
  'airender.fieldLockGeometry': 'Keep 3D model intact',
  'airender.lockOnHint':
    'Locks the geometry to your 3D model (sends a structure guide) — AI changes only materials/scene, not the shape.',
  'airender.lockOffHint': 'Let AI re-imagine the geometry (legacy mode, uses the “preserve design” slider).',
  'airender.fieldPreserveFurniture': 'Preserve cabinet design',
  'airender.fieldContextCreativity': 'Context creativity',
  'airender.creativityNote':
    'Higher "preserve cabinet design" sticks to the original geometry/proportions; higher "context creativity" yields a more elaborate room/scene.',
  'airender.roomSection': 'Auto-generate room space',
  'airender.fieldRoomSource': 'Room source',
  'airender.fieldWall': 'Walls',
  'airender.fieldFloor': 'Floor',
  'airender.fieldCeiling': 'Ceiling',
  'airender.fieldBacksplash': 'Backsplash',
  'airender.fieldIsland': 'Island',
  'airender.fieldAccessory': 'Decor',
  'airender.roomNote': 'This section applies to Interior only.',
  'airender.opt.roomSource.ai-generated': 'AI-generated room',
  'airender.opt.roomSource.use-existing': 'Use existing room in model',
  'airender.opt.wall.auto': 'Auto',
  'airender.opt.wall.light-warm': 'Warm light',
  'airender.opt.wall.matte-white': 'Matte white',
  'airender.opt.wall.soft-concrete': 'Soft concrete',
  'airender.opt.wall.marble-accent': 'Marble accent',
  'airender.opt.wall.wood-accent': 'Wood accent',
  'airender.opt.floor.auto': 'Auto',
  'airender.opt.floor.light-tiles': 'Light tiles',
  'airender.opt.floor.warm-wood': 'Warm wood',
  'airender.opt.floor.light-stone': 'Light stone',
  'airender.opt.floor.matte-concrete': 'Matte concrete',
  'airender.opt.ceiling.auto': 'Auto',
  'airender.opt.ceiling.recessed-spotlights': 'Recessed spotlights',
  'airender.opt.ceiling.linear-led': 'Linear LED',
  'airender.opt.ceiling.pendant-island': 'Island pendant',
  'airender.opt.ceiling.minimal-flat': 'Minimal flat',
  'airender.opt.backsplash.auto': 'Auto',
  'airender.opt.backsplash.light-stone': 'Light stone',
  'airender.opt.backsplash.white-tile': 'White tile',
  'airender.opt.backsplash.marble-slab': 'Marble slab',
  'airender.opt.backsplash.warm-gray': 'Warm gray',
  'airender.opt.backsplash.none': 'None',
  'airender.opt.island.none': 'None',
  'airender.opt.island.one': 'One island',
  'airender.opt.island.auto': 'Auto',
  'airender.opt.accessory.none': 'None',
  'airender.opt.accessory.low': 'Low',
  'airender.opt.accessory.medium': 'Medium',
  'airender.opt.accessory.high': 'High',
  'airender.environmentTextPlaceholder': 'Describe the environment you want…',
  'airender.noModels': 'No AI models available',
  'airender.modelNoKey': 'no key',
  'airender.noKey': 'You have not entered an API key for this provider.',
  'airender.openConsole': 'Open Console',
  'airender.viewAngleNote': 'The view angle is reinterpreted by AI in the image — it does not rotate the 3D model.',
  'airender.statusQueued': 'Queued…',
  'airender.statusRunning': 'Rendering…',
  'airender.failed': 'Render failed',
  'airender.errGeneric': 'Something went wrong — try again',
  'airender.errCap': 'Reached the maximum number of images for this model',
  'airender.errQuota': 'Account storage exceeded',
  'airender.resultHint': 'Frame the scene, then click "Generate" to render.',
  'airender.savedCount': 'Saved: ${n}',
  'airender.save': 'Save',
  'airender.savedBadge': 'Saved',
  'airender.download': 'Download',
  'airender.setThumbnail': 'Set as thumbnail',
  'airender.delete': 'Delete',
  'airender.toastSaved': 'Render saved',
  'airender.toastDeleted': 'Render deleted',
  'airender.toastThumbnail': 'Set as thumbnail',
  'airender.galleryBtn': 'Renders',
  'airender.galleryTitle': 'AI Renders',
  'airender.galleryEmpty': 'No saved renders yet.',
  'airender.prevImage': 'Previous image',
  'airender.nextImage': 'Next image',
  'airender.opt.renderType.architecture': 'Architecture',
  'airender.opt.renderType.landscape': 'Landscape',
  'airender.opt.renderType.interior': 'Interior',
  'airender.opt.lighting.overcast': 'Overcast',
  'airender.opt.lighting.natural': 'Natural',
  'airender.opt.lighting.sunny': 'Sunny',
  'airender.opt.lighting.interior-lights': 'Interior lights',
  'airender.opt.lighting.evening-interior': 'Evening (interior)',
  'airender.opt.lighting.dark-interior': 'Dark (interior)',
  'airender.opt.lighting.studio': 'Studio',
  'airender.opt.lighting.dappled-interior': 'Dappled light (interior)',
  'airender.opt.lighting.golden-hour': 'Golden hour',
  'airender.opt.lighting.indirect-led': 'Indirect LED',
  'airender.opt.lighting.other': 'Other',
  'airender.opt.viewAngle.keep': 'Keep current',
  'airender.opt.viewAngle.front': 'Front',
  'airender.opt.viewAngle.wide': 'Wide angle',
  'airender.opt.viewAngle.drone': 'Aerial (drone)',
  'airender.opt.viewAngle.three-quarter-left': 'Three-quarter left',
  'airender.opt.viewAngle.three-quarter-right': 'Three-quarter right',
  'airender.opt.viewAngle.low': 'Low angle',
  'airender.opt.viewAngle.high': 'High angle',
  'airender.opt.environment.urban': 'Urban',
  'airender.opt.environment.street': 'Street',
  'airender.opt.environment.village': 'Village',
  'airender.opt.environment.countryside': 'Countryside',
  'airender.opt.environment.living-room': 'Living room',
  'airender.opt.environment.bedroom': 'Bedroom',
  'airender.opt.environment.kitchen': 'Kitchen',
  'airender.opt.colorTone.natural': 'Natural',
  'airender.opt.colorTone.warm': 'Warm',
  'airender.opt.colorTone.cool-modern': 'Cool modern',
  'airender.opt.colorTone.bw': 'Black & white',
  'airender.opt.colorTone.vintage-retro': 'Vintage / Retro',
  'airender.opt.colorTone.pastel': 'Pastel',
  'airender.opt.colorTone.cinematic': 'Cinematic',
  'airender.opt.colorTone.modern-warm': 'Warm contemporary',
  'airender.opt.colorTone.luxury': 'Luxury',
  'airender.opt.colorTone.japandi': 'Japandi minimal',
  'airender.opt.colorTone.premium-apartment': 'Premium apartment',
  'airender.opt.colorTone.kitchen-showroom': 'Kitchen showroom',
  'airender.opt.colorTone.scandinavian': 'Scandinavian light',
  // AI model tier labels (04h)
  'airender.opt.quality.very-high': 'Very high quality',
  'airender.opt.quality.high': 'High quality',
  'airender.opt.quality.fair': 'Fair quality',
  'airender.opt.price.very-expensive': 'Very expensive',
  'airender.opt.price.expensive': 'Expensive',
  'airender.opt.price.medium': 'Medium price',
  'airender.opt.price.cheap': 'Cheap',
  'airender.opt.speed.fast': 'Fast render',
  'airender.opt.speed.medium': 'Medium render',
  'airender.opt.speed.slow': 'Slow render',
  'airender.opt.modelTag.new': 'new',
  // Input hints + example prompts (04h)
  'airender.fillExample': 'Auto-fill example',
  // Outdoor scene (10f/04g)
  'airender.archSection': 'Architecture scene',
  'airender.landSection': 'Landscape scene',
  'airender.fieldScene': 'Scene',
  'airender.fieldArchSurrounding': 'Surrounding buildings',
  'airender.fieldArchActivity': 'Activity (people/vehicles)',
  'airender.fieldArchGround': 'Ground',
  'airender.fieldSky': 'Sky',
  'airender.fieldLandTerrain': 'Terrain',
  'airender.fieldLandWater': 'Water',
  'airender.fieldLandHeroTree': 'Hero tree',
  'airender.fieldLandGround': 'Ground',
  'airender.sceneVsEnvNote': 'When you pick a "Scene" below (other than Auto), it replaces "Environment". "Environment" is only used when "Scene" is Auto, or pick "Other" for free text.',
  'airender.opt.archScene.auto': 'Auto',
  'airender.opt.archScene.urban-heritage-street': 'Urban heritage street',
  'airender.opt.archScene.old-town': 'Old town',
  'airender.opt.archScene.modern-city': 'Modern city',
  'airender.opt.archScene.tourist-street': 'Tourist street',
  'airender.opt.archScene.garden-courtyard': 'Garden courtyard',
  'airender.opt.archSurrounding.auto': 'Auto',
  'airender.opt.archSurrounding.low-rise-nearby': 'Low-rise nearby',
  'airender.opt.archSurrounding.high-rise-far': 'High-rise in distance',
  'airender.opt.archSurrounding.mixed': 'Mixed',
  'airender.opt.archSurrounding.none': 'None',
  'airender.opt.archActivity.auto': 'Auto',
  'airender.opt.archActivity.none': 'None',
  'airender.opt.archActivity.light': 'Light',
  'airender.opt.archActivity.medium': 'Medium',
  'airender.opt.archActivity.busy': 'Busy',
  'airender.opt.archGround.auto': 'Auto',
  'airender.opt.archGround.stone-pavement': 'Stone pavement',
  'airender.opt.archGround.sidewalk': 'Sidewalk',
  'airender.opt.archGround.asphalt': 'Asphalt',
  'airender.opt.sky.auto': 'Auto',
  'airender.opt.sky.golden-hour': 'Golden hour',
  'airender.opt.sky.daylight': 'Daylight',
  'airender.opt.sky.clear': 'Clear sky',
  'airender.opt.sky.overcast': 'Overcast',
  'airender.opt.sky.night': 'Night',
  'airender.opt.landScene.auto': 'Auto',
  'airender.opt.landScene.forest': 'Forest',
  'airender.opt.landScene.streamside': 'Streamside',
  'airender.opt.landScene.mountain': 'Mountain',
  'airender.opt.landScene.japanese-garden': 'Japanese garden',
  'airender.opt.landScene.park': 'Park',
  'airender.opt.landScene.old-village': 'Old village',
  'airender.opt.landScene.lakeside': 'Lakeside',
  'airender.opt.landTerrain.auto': 'Auto',
  'airender.opt.landTerrain.forest-clearing': 'Forest clearing',
  'airender.opt.landTerrain.gentle-hill': 'Gentle hill',
  'airender.opt.landTerrain.streamside': 'Streamside',
  'airender.opt.landTerrain.rocky': 'Rocky',
  'airender.opt.landTerrain.paved-path': 'Paved path',
  'airender.opt.landWater.auto': 'Auto',
  'airender.opt.landWater.none': 'None',
  'airender.opt.landWater.stream-beside': 'Stream beside',
  'airender.opt.landWater.stream-front': 'Stream in front',
  'airender.opt.landWater.pond-front': 'Pond in front',
  'airender.opt.landWater.waterfall-back': 'Waterfall behind',
  'airender.opt.landHeroTree.auto': 'Auto',
  'airender.opt.landHeroTree.none': 'None',
  'airender.opt.landHeroTree.ancient-pine-behind': 'Ancient pine behind',
  'airender.opt.landHeroTree.red-maple': 'Red maple',
  'airender.opt.landHeroTree.bamboo': 'Bamboo',
  'airender.opt.landHeroTree.natural-forest': 'Natural forest',
  'airender.opt.landGround.auto': 'Auto',
  'airender.opt.landGround.stone-and-moss': 'Stone and moss',
  'airender.opt.landGround.grass': 'Grass',
  'airender.opt.landGround.dirt': 'Dirt',
  'airender.hint.renderType': 'Pick the type of image to create: an interior room, an architectural building, or an outdoor landscape.',
  'airender.hint.environment': 'The setting / room type around the product (e.g. living room, street). Pick "Other" to type your own.',
  'airender.hint.lighting': 'Lighting style for the image — pick zero or more; leave empty to let the AI decide.',
  'airender.hint.colorTone': 'Overall color tone / styling — pick zero or more; leave empty to let the AI decide.',
  'airender.hint.materials': 'Materials to emphasize in the image — pick several; "Keep" sticks to the original materials.',
  'airender.hint.model': 'Choose the AI model used for rendering (from providers you have entered a key for).',
  'airender.hint.negative': 'List what you do NOT want to appear (e.g. people, text, distortion).',
  'airender.hint.desc.interior': 'Describe the room type, how the furniture attaches to walls/floor/ceiling, appliances to add, decor, the feel of the space, and any details that must be kept.',
  'airender.hint.desc.architecture': 'Describe the building, its surroundings, the activity in the scene, the main materials, and details that must not break the original design.',
  'airender.hint.desc.landscape': 'Describe the terrain, vegetation, water, rocks, ground, background, and where the subject sits in the scene. State clearly what is in front of, beside, or behind the subject.',
  'airender.ex.interior.1': 'A modern open-plan kitchen flooded with natural light from a large glass wall. The wooden cabinet system is perfectly fitted flush against the wall, with a cloudy quartz stone countertop. A range hood is installed. On the counter, a small potted plant, a basket of fresh fruit, an espresso machine and a KitchenAid mixer add accents. A large, beautiful split-leaf monstera plant stands beside the refrigerator. A Vietnamese housewife is looking at the food. A Vietnamese baby clings to her mother\'s legs. On the island sits a tray of delicious, lavish food.',
  'airender.ex.interior.2': 'The kitchen cabinets are fixed onto two perpendicular walls of the kitchen. The cabinets include a range hood, an oven and a built-in microwave. On the countertop sit an induction cooktop, a small plant and a KitchenAid mixer. In the middle of the room is a kitchen island matching the stone countertop. The space should feel warm, clean, high-end and not over-decorated.',
  'airender.ex.interior.3': 'A TV cabinet fitted flush against the main wall of the living room. Around it are light-colored walls, a warm wood floor, a low sofa in front and a small coffee table. On the unit are a few light decor pieces, a small plant and soft wall-wash lighting. The space should be modern, tidy, luxurious and keep the original cabinet design.',
  'airender.ex.interior.4': 'A wardrobe placed flush against the wall in the bedroom, with a small dressing table and mirror beside it. The room has a low bed, light-colored curtains, a wood floor and soft warm light. The space should feel warm, relaxing, clean and high-end. Keep the original layout, proportions and main materials of the wardrobe system.',
  'airender.ex.landscape.1': 'A traditional wooden resting pavilion set in a lush tropical eco-garden. The structure stands firmly on gravel-covered ground and natural boulders, surrounded by fern bushes and mossy stones. A small babbling stream runs alongside. The brilliant golden sunset light filters through the leaves, casting soft shadows onto the tiled roof.',
  'airender.ex.landscape.2': 'A wooden temple set in a quiet patch of forest. A small stream runs beside the temple, with natural rocks and green moss in front. Behind the temple stands a large ancient pine, surrounded by dense green forest that does not hide the structure. The atmosphere is peaceful, natural and full of depth.',
  'airender.ex.landscape.3': 'A pavilion sitting in the middle of a wide park. Around it are grass lawns, stone-paved paths, low greenery and a few large trees in the background. An open courtyard in front gives a clear view of the whole structure. The scenery should be bright, airy, natural and suitable for an outdoor architectural showcase.',
  'airender.ex.landscape.4': 'The structure stands on a gentle hillside overlooking a green valley in the distance. Around it are grass, natural rocks, low shrubs and a few large trees. The background has faint hazy mountains and a clear sky. The subject should stand out and not be obscured by vegetation.',
  'airender.ex.architecture.1': 'A wooden stall in a traditional East Asian style stands out on a bustling stone-paved walking street. Around it are rows of modern townhouses with hazy street lights in the distance. A dusk twilight atmosphere. Soft warm light from recessed LED ceiling lamps spills onto the street, creating a perfect blend of classical architecture and urban life.',
  'airender.ex.architecture.2': 'A period-style cafe on the corner of a crowded neighborhood. Nearby are a few low-rise houses, with modern high-rise blocks in the distance. In front of the cafe is a stone-paved sidewalk, a few pedestrians and vehicles behind, but they do not hide the facade. The structure must clearly keep its curved roof, wooden frame, glass panels and the front counter area.',
  'airender.ex.architecture.3': 'A furniture showroom on a modern street. The facade faces a main road, with a wide sidewalk, urban greenery and a few cars parked at the curb in front. Modern low-rise buildings flank both sides. The space should be clean, high-end and suitable for a commercial showcase image.',
  'airender.ex.architecture.4': 'A wooden retreat house by a lake, surrounded by greenery, stone-paved paths and a small front yard. Behind it is light forest and a water surface reflecting the light. Keep the original architectural massing, roof, wood materials and proportions of the structure.',
  'airender.opt.environment.other': 'Other',
  'airender.opt.material.keep': 'Keep as in source image',
  'airender.opt.material.wood': 'Wood',
  'airender.opt.material.glass': 'Glass',
  'airender.opt.material.stone': 'Stone',
  'airender.opt.material.brick': 'Brick',
  'airender.opt.material.marble': 'Marble',
  'airender.opt.material.aluminum-glass': 'Aluminum & glass',
  'airender.opt.material.ceramic': 'Ceramic',
  'airender.opt.material.bamboo-rattan': 'Bamboo / Rattan',
  'airender.opt.material.composite-panel': 'Composite panel',
  'airender.opt.material.laterite': 'Laterite',
  'airender.opt.material.concrete': 'Concrete',
};

// ⚠ ru/zh/th: NHÁP máy-dịch — chờ người bản ngữ duyệt.
const ru: Dict = {
  'app.loading': 'Загрузка модели…',
  'app.noToken': 'В ссылке не найден код модели.',
  'app.retry': 'Повторить',
  'err.private.title': 'Приватная модель',
  'err.private.body': 'Эта модель приватная. Чтобы её посмотреть, нужна ссылка Author от владельца.',
  'err.notfound.title': 'Модель не найдена',
  'err.notfound.body': 'Ссылка не существует или истекла. Проверьте ссылку у отправителя.',
  'err.version.title': 'Нужно обновить просмотрщик',
  'err.version.body': 'Модель использует более новый формат, чем текущий просмотрщик. Повторите попытку позже.',
  'err.empty.title': 'Пустая модель',
  'err.empty.body': 'В этой модели нет деталей для отображения.',
  'err.network.title': 'Не удалось загрузить модель',
  'err.network.body': 'Ошибка соединения. Проверьте сеть и повторите попытку.',
  'err.webgl.title': 'Не удаётся показать 3D-модель',
  'err.webgl.body':
    'В вашем браузере на этом компьютере не включено аппаратное ускорение (WebGL). Включите «Использовать аппаратное ускорение» в настройках браузера и перезапустите его, обновите драйвер видеокарты или попробуйте другой браузер. Если вы работаете через удалённый рабочий стол или виртуальную машину, откройте ссылку напрямую на устройстве с видеокартой.',

  'parts.count.one': '${n} деталь',
  'parts.count.few': '${n} детали',
  'parts.count.many': '${n} деталей',
  'parts.count.other': '${n} детали',

  'side.title': 'Детали модели',
  'common.share': 'Поделиться',
  'common.close': 'Закрыть',
  'common.overview': 'Обзор',
  'common.zoomSelected': 'Приблизить к выбранной детали',
  'author.editBadge': 'Режим редактирования',
  'author.lockedBadge': 'Заблокировано — нельзя сохранить',

  'ctx.open': 'Открыть',
  'ctx.close': 'Закрыть',
  'ctx.hide': 'Скрыть деталь',
  'ctx.isolate': 'Скрыть остальные детали',

  'toast.locked': 'Модель заблокирована для обновления',
  'toast.saved': 'Изменения сохранены',
  'toast.badEditLink': 'Недействительная ссылка редактирования',
  'toast.saveFailed': 'Не удалось сохранить — повторите',
  'toast.copiedLink': 'Ссылка скопирована',
  'toast.copiedEmbed': 'Код встраивания скопирован',

  'tb.material': 'Материал',
  'tb.matedge': 'Материал с рёбрами',
  'tb.wireframe': 'Каркас',
  'tb.wireframeHidden': 'Каркас + скрытые',
  'tb.xray': 'Рентген',
  'tb.projection': 'Проекция',
  'tb.viewIso': 'Перспектива',
  'tb.viewFront': 'Спереди',
  'tb.viewLeft': 'Слева',
  'tb.viewRight': 'Справа',
  'tb.viewTop': 'Сверху',
  'tb.fit': 'Вписать в экран',
  'tb.openAll': 'Открыть всё',
  'tb.closeAll': 'Закрыть всё',
  'tb.fullscreen': 'Во весь экран',
  'tb.measure': 'Измерить',
  'tb.lighting': 'Освещение',
  'tb.dimensions': 'Размеры',
  'explode.title': 'Разнесённый вид',
  'explode.amount': 'Степень разнесения',
  'list.selectGroup': 'Выбрать группу',
  'list.selectAll': 'Выбрать все группы',
  'sel.count': 'Выбрано групп: ${n}',
  'sel.part': 'Выбранная деталь',
  'sel.hidden': 'Детали скрыты',
  'sel.explode': 'Разнести',
  'sel.hide': 'Скрыть группу',
  'sel.hideOthers': 'Скрыть остальное',
  'sel.labels': 'Выноски',
  'sel.clear': 'Сбросить',
  'tb.toolbar': 'Инструменты просмотра',
  'tb.modeGroup': 'Режим отображения',
  'tb.viewGroup': 'Вид',

  'list.search': 'Поиск деталей…',
  'list.scan': 'Сканировать код детали',
  'list.empty': 'Подходящих деталей не найдено.',
  'list.moduleOther': 'Прочее',
  'list.codePrefix': '№ ${code}',
  'list.toggleMotion': 'Открыть / закрыть',
  'list.show': 'Показать деталь',
  'list.hide': 'Скрыть деталь',
  'list.showGroup': 'Показать группу',
  'list.hideGroup': 'Скрыть группу',
  'list.showAll': 'Показать все',
  'list.collapse': 'Свернуть группу',
  'list.expand': 'Развернуть группу',
  'list.collapseAll': 'Свернуть все',
  'list.expandAll': 'Развернуть все',

  'info.selecting': 'Выбрано',
  'info.code': '№ детали',
  'info.dims': 'Размеры',
  'info.material': 'Материал',
  'info.motion': 'Движение',

  'motion.0': 'Неподвижно',
  'motion.2': 'Дверь на правых петлях',
  'motion.3': 'Дверь на левых петлях',
  'motion.4': 'Откидная дверь вниз',
  'motion.5': 'Подъёмная дверь',
  'motion.6': 'Раздвижная дверь влево',
  'motion.7': 'Раздвижная дверь вправо',
  'motion.8': 'Корпус ящика',
  'motion.11': 'Фасад ящика',
  'motion.12': 'Aventos HS (дуговой подъём)',
  'motion.13': 'Поршень (прямой подъём)',
  'motion.14': 'Aventos HF (складной)',
  'motion.15': 'Глубокое выдвижение (Z)',

  'author.motionTitle': 'Настройки движения',
  'author.lockedBanner': 'Модель заблокирована для обновления — нельзя сохранить',
  'author.selectPart': 'Выберите деталь на модели, чтобы задать способ открытия.',
  'author.assigningTo': 'Назначается для:',
  'author.catDoor': 'Дверь',
  'author.catDrawer': 'Ящик',
  'author.catAdvanced': 'Расширенное',
  'author.groupRel': 'Согласование движения',
  'author.groupRelHint': 'По умолчанию каждая деталь движется отдельно. Объединяйте, только если несколько деталей должны двигаться вместе (напр. ручка + дверца, фасад + корпус ящика).',
  'author.relIndependent': 'Отдельно',
  'author.relIndependentSub': 'Движется самостоятельно',
  'author.relMergeWith': 'Вместе с',
  'author.groupShort': 'Группа',
  'author.catOptions': 'Параметры',
  'author.mHingeL': 'Левая петля',
  'author.mHingeR': 'Правая петля',
  'author.mLiftDown': 'Откинуть вниз',
  'author.mLiftUp': 'Поднять',
  'author.mSlideL': 'Сдвинуть влево',
  'author.mSlideR': 'Сдвинуть вправо',
  'author.mDrawerBody': 'Корпус ящика',
  'author.mDrawerFront': 'Фасад ящика',
  'author.mAventosHS': 'Aventos HS',
  'author.mAventosHF': 'Подъёмник Blum',
  'author.mPiston': 'Поршень',
  'author.mDeepSlide': 'Глубокое выдвижение',
  'author.flip': 'Перевернуть',
  'author.flipHint': 'Сменить сторону петли (лево/право).',
  'author.swingOut': 'Открывать внутрь/наружу',
  'author.swingOutHint': 'Дверь открывается внутрь корпуса? Переключите направление внутрь/наружу (не путать с левой/правой петлёй).',
  'author.clearAssign': 'Снять',
  'author.save': 'Сохранить изменения',
  'author.saving': 'Сохранение…',
  'author.lightTitle': 'Освещение',
  'author.lightApplyAll': 'Применяется ко всем зрителям после нажатия «Сохранить изменения».',
  'author.lightOnState': 'Освещение включено',
  'author.lightOffState': 'Выключено — плоский показ',
  'author.lightOnHint': 'Нажмите, чтобы ВЫКЛЮЧИТЬ эффекты: модель плоская (полный цвет + текстура), но без теней, бликов и объёма — НЕ темнеет.',
  'author.lightOffHint': 'Нажмите, чтобы ВКЛЮЧИТЬ: вернуть объём, тени и яркость согласно выбранному освещению.',
  'author.lightKind': 'Тип освещения',
  'author.lightEven': 'Равномерное',
  'author.lightStudio': 'Студийное',
  'author.lightBright': 'Ярче',
  'author.lightEvenHint': 'Свет падает с разных сторон, поэтому ни одна грань не остаётся тёмной; цвет и текстура хорошо читаются под любым углом, мягкие тени. Хорошо для осмотра деталей.',
  'author.lightStudioHint': 'Схема из 3 источников даёт объём, глубину и чёткие тени с высоким контрастом. Хорошо для презентации / съёмки изделия.',
  'author.lightBrightHint': 'Повышает общий рассеянный свет и уменьшает тёмные зоны, делая всю модель ярче и ровнее. Хорошо для тёмных материалов / цветов.',
  'author.lightIntensity': 'Яркость',
  'author.lightIntensityHint': '50 = стандарт для выбранного типа · 100 = вдвое ярче · 0 = темно.',

  'measure.title': 'Измерение',
  'measure.total': 'Габариты',
  'measure.inner': 'В свету',
  'measure.manual': 'Вручную',
  'measure.clear': 'Очистить',
  'measure.manualHint': 'Нажмите 2 точки на модели, чтобы измерить расстояние.',
  'measure.innerHint': 'Нажмите 2 параллельные панели — на модели или в списке.',
  'measure.distance': 'Расстояние = ${mm} мм',
  'measure.point1': 'Точка 1 задана — нажмите 2-ю точку.',
  'measure.innerPick': 'Нажмите панель ${n}',
  'measure.innerPick2': 'Нажмите 2-ю параллельную панель (стенка, полка, фасад, задник)',
  'measure.innerSameDir': 'Выберите 2 параллельные панели',
  'measure.innerResult': 'В свету = ${mm} мм',
  'measure.innerGapResult': 'Зазор = ${mm} мм',
  'measure.innerOverlap': 'Панели перекрываются — нет зазора для измерения',
  'measure.innerNoDir': 'Не удалось определить направление панели (гнутая или наклонная)',
  'measure.innerRotateHint': '↻ Поверните вид, чтобы увидеть размер',

  'hints.title': 'Подсказки по жестам',
  'hints.rotate': '1 палец: вращать модель',
  'hints.pan': '2 пальца: перемещение и масштаб',
  'hints.dblTap': 'Двойное касание: открыть/закрыть дверцы и ящики',
  'hints.ok': 'Понятно',

  'scan.title': 'Сканировать код детали',
  'scan.opening': 'Открытие камеры…',
  'scan.aim': 'Наведите QR-код детали в рамку',
  'scan.zoom': 'Приблизить бирку',
  'scan.badFormat': 'Код "${text}" имеет неверный формат. Отсканируйте другой код.',
  'scan.notFound': 'Деталь по коду "${text}" не найдена.',
  'scan.noSupport': 'Браузер не поддерживает камеру (нужен HTTPS или localhost).',
  'scan.noAccess': 'Не удалось получить доступ к камере. Разрешите доступ к камере (нужен HTTPS или localhost) и повторите.',

  'share.title': 'Поделиться моделью',
  'share.qrFallback': 'Для QR-кода нужно подключение к серверу',
  'share.copyLink': 'Копировать ссылку',
  'share.embedLabel': 'Код встраивания (iframe)',
  'share.copyEmbed': 'Копировать код встраивания',

  'lang.label': 'Язык',

  // ----- AI Render (04a) — машинный черновик, ждёт носителя языка -----
  'airender.title': 'AI-рендер',
  'airender.open': 'AI-рендер ✨',
  'airender.generate': 'Создать',
  'airender.generating': 'Создание…',
  'airender.fieldRenderType': 'Тип рендера',
  'airender.fieldLighting': 'Освещение',
  'airender.fieldViewAngle': 'Ракурс',
  'airender.fieldEnvironment': 'Окружение',
  'airender.fieldColorTone': 'Цветовой тон',
  'airender.fieldAspect': 'Соотношение сторон',
  'airender.fieldModel': 'AI-модель',
  'airender.fieldDescription': 'Описание',
  'airender.fieldCreativity': 'Креативность',
  'airender.descPlaceholder': 'Добавьте детали желаемой сцены…',
  'airender.fieldMaterials': 'Материалы',
  'airender.fieldNegative': 'Негативный промпт',
  'airender.negativePlaceholder': 'Нежелательные объекты, искажения…',
  'airender.fieldEnvironmentText': 'Другое окружение',
  'airender.fieldLightingText': 'Другое освещение',
  'airender.lightingTextPlaceholder': 'Опишите своё освещение…',
  'airender.fieldSize': 'Размер',
  'airender.sizeNote': 'Размер — разрешение снимка-основы; соотношение кадра определяет результат ИИ.',
  'airender.opt.size.1024x1024': 'Квадрат (1024×1024)',
  'airender.opt.size.1080x1080': 'Квадрат для соцсетей (1080×1080)',
  'airender.opt.size.1536x1024': 'Альбомная (1536×1024)',
  'airender.opt.size.1024x1536': 'Портретная (1024×1536)',
  'airender.opt.size.1920x1080': 'Full HD альбомная (1920×1080)',
  'airender.opt.size.1080x1920': 'Full HD портретная (1080×1920)',
  'airender.opt.size.1280x720': 'HD альбомная (1280×720)',
  'airender.opt.size.2048x2048': 'Большой квадрат (2048×2048)',
  // v3 (10e/04f): две шкалы креативности + автосоздание комнаты
  'airender.fieldLockGeometry': 'Сохранить 3D-модель',
  'airender.lockOnHint':
    'Жёстко фиксирует форму по 3D-модели (отправляется структурный ориентир) — ИИ меняет только материалы/окружение, не форму.',
  'airender.lockOffHint': 'Разрешить ИИ переосмыслить форму (старый режим, ползунок «сохранить дизайн»).',
  'airender.fieldPreserveFurniture': 'Сохранить дизайн шкафа',
  'airender.fieldContextCreativity': 'Креативность фона',
  'airender.creativityNote':
    'Выше «сохранение дизайна» — точнее геометрия/пропорции исходного шкафа; выше «креативность фона» — детальнее комната/сцена.',
  'airender.roomSection': 'Автосоздание пространства комнаты',
  'airender.fieldRoomSource': 'Источник комнаты',
  'airender.fieldWall': 'Стены',
  'airender.fieldFloor': 'Пол',
  'airender.fieldCeiling': 'Потолок',
  'airender.fieldBacksplash': 'Фартук',
  'airender.fieldIsland': 'Остров',
  'airender.fieldAccessory': 'Декор',
  'airender.roomNote': 'Этот раздел только для интерьера.',
  'airender.opt.roomSource.ai-generated': 'Комната, созданная ИИ',
  'airender.opt.roomSource.use-existing': 'Использовать комнату из модели',
  'airender.opt.wall.auto': 'Авто',
  'airender.opt.wall.light-warm': 'Тёплый свет',
  'airender.opt.wall.matte-white': 'Матовый белый',
  'airender.opt.wall.soft-concrete': 'Мягкий бетон',
  'airender.opt.wall.marble-accent': 'Мраморный акцент',
  'airender.opt.wall.wood-accent': 'Деревянный акцент',
  'airender.opt.floor.auto': 'Авто',
  'airender.opt.floor.light-tiles': 'Светлая плитка',
  'airender.opt.floor.warm-wood': 'Тёплое дерево',
  'airender.opt.floor.light-stone': 'Светлый камень',
  'airender.opt.floor.matte-concrete': 'Матовый бетон',
  'airender.opt.ceiling.auto': 'Авто',
  'airender.opt.ceiling.recessed-spotlights': 'Встроенные споты',
  'airender.opt.ceiling.linear-led': 'Линейный LED',
  'airender.opt.ceiling.pendant-island': 'Подвес над островом',
  'airender.opt.ceiling.minimal-flat': 'Минимализм, плоский',
  'airender.opt.backsplash.auto': 'Авто',
  'airender.opt.backsplash.light-stone': 'Светлый камень',
  'airender.opt.backsplash.white-tile': 'Белая плитка',
  'airender.opt.backsplash.marble-slab': 'Мраморная плита',
  'airender.opt.backsplash.warm-gray': 'Тёплый серый',
  'airender.opt.backsplash.none': 'Нет',
  'airender.opt.island.none': 'Нет',
  'airender.opt.island.one': 'Один остров',
  'airender.opt.island.auto': 'Авто',
  'airender.opt.accessory.none': 'Нет',
  'airender.opt.accessory.low': 'Мало',
  'airender.opt.accessory.medium': 'Средне',
  'airender.opt.accessory.high': 'Много',
  'airender.environmentTextPlaceholder': 'Опишите желаемое окружение…',
  'airender.noModels': 'Нет доступных AI-моделей',
  'airender.modelNoKey': 'нет ключа',
  'airender.noKey': 'Вы не ввели API-ключ для этого провайдера.',
  'airender.openConsole': 'Открыть консоль',
  'airender.viewAngleNote': 'Ракурс интерпретируется ИИ на изображении — модель не поворачивается.',
  'airender.statusQueued': 'В очереди…',
  'airender.statusRunning': 'Рендеринг…',
  'airender.failed': 'Ошибка рендера',
  'airender.errGeneric': 'Произошла ошибка — повторите',
  'airender.errCap': 'Достигнут лимит изображений для этой модели',
  'airender.errQuota': 'Превышен объём хранилища',
  'airender.resultHint': 'Настройте сцену и нажмите «Создать».',
  'airender.savedCount': 'Сохранено: ${n}',
  'airender.save': 'Сохранить',
  'airender.savedBadge': 'Сохранено',
  'airender.download': 'Скачать',
  'airender.setThumbnail': 'Сделать обложкой',
  'airender.delete': 'Удалить',
  'airender.toastSaved': 'Рендер сохранён',
  'airender.toastDeleted': 'Рендер удалён',
  'airender.toastThumbnail': 'Установлено как обложка',
  'airender.galleryBtn': 'Рендеры',
  'airender.galleryTitle': 'AI-рендеры',
  'airender.galleryEmpty': 'Пока нет сохранённых рендеров.',
  'airender.prevImage': 'Предыдущее изображение',
  'airender.nextImage': 'Следующее изображение',
  'airender.opt.renderType.architecture': 'Архитектура',
  'airender.opt.renderType.landscape': 'Пейзаж',
  'airender.opt.renderType.interior': 'Интерьер',
  'airender.opt.lighting.overcast': 'Пасмурно',
  'airender.opt.lighting.natural': 'Естественный',
  'airender.opt.lighting.sunny': 'Солнечно',
  'airender.opt.lighting.interior-lights': 'Внутреннее освещение',
  'airender.opt.lighting.evening-interior': 'Вечер (интерьер)',
  'airender.opt.lighting.dark-interior': 'Тёмный (интерьер)',
  'airender.opt.lighting.studio': 'Студия',
  'airender.opt.lighting.dappled-interior': 'Пятнистый свет (интерьер)',
  'airender.opt.lighting.golden-hour': 'Золотой час',
  'airender.opt.lighting.indirect-led': 'Непрямой LED',
  'airender.opt.lighting.other': 'Другое',
  'airender.opt.viewAngle.keep': 'Как есть',
  'airender.opt.viewAngle.front': 'Спереди',
  'airender.opt.viewAngle.wide': 'Широкий угол',
  'airender.opt.viewAngle.drone': 'С высоты (дрон)',
  'airender.opt.viewAngle.three-quarter-left': 'Три четверти слева',
  'airender.opt.viewAngle.three-quarter-right': 'Три четверти справа',
  'airender.opt.viewAngle.low': 'Нижний ракурс',
  'airender.opt.viewAngle.high': 'Верхний ракурс',
  'airender.opt.environment.urban': 'Город',
  'airender.opt.environment.street': 'Улица',
  'airender.opt.environment.village': 'Деревня',
  'airender.opt.environment.countryside': 'Сельская местность',
  'airender.opt.environment.living-room': 'Гостиная',
  'airender.opt.environment.bedroom': 'Спальня',
  'airender.opt.environment.kitchen': 'Кухня',
  'airender.opt.colorTone.natural': 'Естественный',
  'airender.opt.colorTone.warm': 'Тёплый',
  'airender.opt.colorTone.cool-modern': 'Холодный современный',
  'airender.opt.colorTone.bw': 'Чёрно-белый',
  'airender.opt.colorTone.vintage-retro': 'Винтаж / Ретро',
  'airender.opt.colorTone.pastel': 'Пастель',
  'airender.opt.colorTone.cinematic': 'Кинематографичный',
  'airender.opt.colorTone.modern-warm': 'Тёплый современный',
  'airender.opt.colorTone.luxury': 'Люкс',
  'airender.opt.colorTone.japandi': 'Джапанди минимализм',
  'airender.opt.colorTone.premium-apartment': 'Премиум-квартира',
  'airender.opt.colorTone.kitchen-showroom': 'Кухонный шоурум',
  'airender.opt.colorTone.scandinavian': 'Скандинавский светлый',
  // Метки уровней модели ИИ (04h)
  'airender.opt.quality.very-high': 'Очень высокое качество',
  'airender.opt.quality.high': 'Высокое качество',
  'airender.opt.quality.fair': 'Среднее качество',
  'airender.opt.price.very-expensive': 'Очень дорого',
  'airender.opt.price.expensive': 'Дорого',
  'airender.opt.price.medium': 'Средняя цена',
  'airender.opt.price.cheap': 'Дёшево',
  'airender.opt.speed.fast': 'Быстрый рендер',
  'airender.opt.speed.medium': 'Средний рендер',
  'airender.opt.speed.slow': 'Медленный рендер',
  'airender.opt.modelTag.new': 'новый',
  // Подсказки к полям + примеры запросов (04h)
  'airender.fillExample': 'Подставить пример',
  // Сцена ландшафта/архитектуры (10f/04g)
  'airender.archSection': 'Сцена: архитектура',
  'airender.landSection': 'Сцена: ландшафт',
  'airender.fieldScene': 'Сцена',
  'airender.fieldArchSurrounding': 'Окружающие здания',
  'airender.fieldArchActivity': 'Активность (люди/транспорт)',
  'airender.fieldArchGround': 'Покрытие',
  'airender.fieldSky': 'Небо',
  'airender.fieldLandTerrain': 'Рельеф',
  'airender.fieldLandWater': 'Вода',
  'airender.fieldLandHeroTree': 'Главное дерево',
  'airender.fieldLandGround': 'Грунт',
  'airender.sceneVsEnvNote': 'Если выбрать «Сцену» ниже (не «Авто»), она заменяет «Окружение». «Окружение» используется только когда «Сцена» = Авто, или выберите «Другое» для свободного описания.',
  'airender.opt.archScene.auto': 'Авто',
  'airender.opt.archScene.urban-heritage-street': 'Историческая городская улица',
  'airender.opt.archScene.old-town': 'Старый город',
  'airender.opt.archScene.modern-city': 'Современный город',
  'airender.opt.archScene.tourist-street': 'Туристическая улица',
  'airender.opt.archScene.garden-courtyard': 'Садовый двор',
  'airender.opt.archSurrounding.auto': 'Авто',
  'airender.opt.archSurrounding.low-rise-nearby': 'Малоэтажные рядом',
  'airender.opt.archSurrounding.high-rise-far': 'Высотки вдали',
  'airender.opt.archSurrounding.mixed': 'Смешанные',
  'airender.opt.archSurrounding.none': 'Нет',
  'airender.opt.archActivity.auto': 'Авто',
  'airender.opt.archActivity.none': 'Нет',
  'airender.opt.archActivity.light': 'Слабая',
  'airender.opt.archActivity.medium': 'Средняя',
  'airender.opt.archActivity.busy': 'Оживлённая',
  'airender.opt.archGround.auto': 'Авто',
  'airender.opt.archGround.stone-pavement': 'Каменная мостовая',
  'airender.opt.archGround.sidewalk': 'Тротуар',
  'airender.opt.archGround.asphalt': 'Асфальт',
  'airender.opt.sky.auto': 'Авто',
  'airender.opt.sky.golden-hour': 'Золотой час',
  'airender.opt.sky.daylight': 'Дневной свет',
  'airender.opt.sky.clear': 'Ясное небо',
  'airender.opt.sky.overcast': 'Пасмурно',
  'airender.opt.sky.night': 'Ночь',
  'airender.opt.landScene.auto': 'Авто',
  'airender.opt.landScene.forest': 'Лес',
  'airender.opt.landScene.streamside': 'У ручья',
  'airender.opt.landScene.mountain': 'Горы',
  'airender.opt.landScene.japanese-garden': 'Японский сад',
  'airender.opt.landScene.park': 'Парк',
  'airender.opt.landScene.old-village': 'Старая деревня',
  'airender.opt.landScene.lakeside': 'У озера',
  'airender.opt.landTerrain.auto': 'Авто',
  'airender.opt.landTerrain.forest-clearing': 'Лесная поляна',
  'airender.opt.landTerrain.gentle-hill': 'Пологий холм',
  'airender.opt.landTerrain.streamside': 'У ручья',
  'airender.opt.landTerrain.rocky': 'Каменистый',
  'airender.opt.landTerrain.paved-path': 'Мощёная дорожка',
  'airender.opt.landWater.auto': 'Авто',
  'airender.opt.landWater.none': 'Нет',
  'airender.opt.landWater.stream-beside': 'Ручей рядом',
  'airender.opt.landWater.stream-front': 'Ручей впереди',
  'airender.opt.landWater.pond-front': 'Пруд впереди',
  'airender.opt.landWater.waterfall-back': 'Водопад позади',
  'airender.opt.landHeroTree.auto': 'Авто',
  'airender.opt.landHeroTree.none': 'Нет',
  'airender.opt.landHeroTree.ancient-pine-behind': 'Старая сосна позади',
  'airender.opt.landHeroTree.red-maple': 'Красный клён',
  'airender.opt.landHeroTree.bamboo': 'Бамбук',
  'airender.opt.landHeroTree.natural-forest': 'Естественный лес',
  'airender.opt.landGround.auto': 'Авто',
  'airender.opt.landGround.stone-and-moss': 'Камни и мох',
  'airender.opt.landGround.grass': 'Трава',
  'airender.opt.landGround.dirt': 'Земля',
  'airender.hint.renderType': 'Выберите тип изображения: интерьер комнаты, архитектурное сооружение или наружный ландшафт.',
  'airender.hint.environment': 'Окружение / тип помещения вокруг изделия (напр. гостиная, улица). Выберите «Другое», чтобы ввести своё.',
  'airender.hint.lighting': 'Стиль освещения — выберите ноль или несколько; пусто = ИИ решит сам.',
  'airender.hint.colorTone': 'Общий цветовой тон / стилистика — выберите ноль или несколько; пусто = ИИ решит сам.',
  'airender.hint.materials': 'Материалы, которые подчеркнуть на изображении — выберите несколько; «Сохранить» = оставить исходные материалы.',
  'airender.hint.model': 'Выберите модель ИИ для рендеринга (из провайдеров, для которых вы ввели ключ).',
  'airender.hint.negative': 'Перечислите, чего НЕ должно быть на изображении (напр. люди, текст, искажения).',
  'airender.hint.desc.interior': 'Опишите тип комнаты, как мебель примыкает к стенам/полу/потолку, какую технику добавить, декор, ощущение пространства и детали, которые обязательно сохранить.',
  'airender.hint.desc.architecture': 'Опишите сооружение, его окружение, действие в сцене, основные материалы и детали, которые не должны нарушать исходный дизайн.',
  'airender.hint.desc.landscape': 'Опишите рельеф, растительность, воду, камни, грунт, задний план и положение объекта в сцене. Чётко укажите, что находится перед, рядом или позади объекта.',
  'airender.ex.interior.1': 'Современная кухня открытой планировки, залитая естественным светом из большой стеклянной стены. Деревянный гарнитур идеально установлен вплотную к стене, столешница из кварца с облачным рисунком. Установлена кухонная вытяжка. На столешнице — небольшое растение в горшке, корзина свежих фруктов, эспрессо-машина и миксер KitchenAid. Рядом с холодильником стоит большая красивая монстера с резными листьями. Вьетнамская хозяйка смотрит на еду. Вьетнамский малыш держится за ноги мамы. На острове стоит поднос с вкусной, обильной едой.',
  'airender.ex.interior.2': 'Кухонные шкафы закреплены на двух перпендикулярных стенах кухни. В шкафах — вытяжка, духовка и встроенная микроволновка. На столешнице — индукционная плита, небольшое растение и миксер KitchenAid. В центре комнаты — кухонный остров в тон каменной столешнице. Пространство должно быть тёплым, чистым, премиальным и без избытка декора.',
  'airender.ex.interior.3': 'ТВ-тумба установлена вплотную к главной стене гостиной. Вокруг — светлые стены, тёплый деревянный пол, низкий диван впереди и небольшой журнальный столик. На тумбе — пара лёгких элементов декора, небольшое растение и мягкая подсветка стены. Пространство должно быть современным, аккуратным, роскошным и сохранять исходный дизайн тумбы.',
  'airender.ex.interior.4': 'Шкаф установлен вплотную к стене в спальне, рядом — небольшой туалетный столик и зеркало. В комнате низкая кровать, светлые шторы, деревянный пол и мягкий тёплый свет. Пространство должно быть тёплым, расслабляющим, чистым и премиальным. Сохраните исходную компоновку, пропорции и основные материалы шкафа.',
  'airender.ex.landscape.1': 'Традиционная деревянная беседка для отдыха среди пышного тропического эко-сада. Сооружение прочно стоит на засыпанной гравием земле и природных валунах, в окружении папоротников и замшелых камней. Рядом журчит небольшой ручей. Яркий золотой закатный свет проникает сквозь листву, отбрасывая мягкие тени на черепичную крышу.',
  'airender.ex.landscape.2': 'Деревянный храм в тихом уголке леса. Рядом с храмом протекает небольшой ручей, впереди — природные камни и зелёный мох. За храмом — большая старая сосна, вокруг густой зелёный лес, который не скрывает сооружение. Атмосфера спокойная, естественная и глубокая.',
  'airender.ex.landscape.3': 'Павильон посреди широкого парка. Вокруг — газоны, мощёные камнем дорожки, низкая зелень и несколько крупных деревьев на заднем плане. Впереди открытая площадка для полного обзора сооружения. Пейзаж должен быть светлым, просторным, естественным и подходящим для наружной архитектурной презентации.',
  'airender.ex.landscape.4': 'Сооружение стоит на пологом склоне холма с видом на зелёную долину вдали. Вокруг — трава, природные камни, низкие кусты и несколько крупных деревьев. На заднем плане — лёгкая дымка гор и ясное небо. Объект должен выделяться и не быть скрытым растительностью.',
  'airender.ex.architecture.1': 'Деревянный павильон в традиционном восточноазиатском стиле выделяется на оживлённой мощёной пешеходной улице. Вокруг — ряды современных таунхаусов с размытыми уличными огнями вдали. Сумеречная атмосфера. Мягкий тёплый свет встроенных потолочных LED-светильников ложится на мостовую, создавая идеальное сочетание классической архитектуры и городской жизни.',
  'airender.ex.architecture.2': 'Кафе в старинном стиле на углу людного квартала. Рядом несколько малоэтажных домов, вдали — современные высотки. Перед кафе мощёный камнем тротуар, несколько пешеходов и транспорт позади, но они не скрывают фасад. Сооружение должно чётко сохранять изогнутую крышу, деревянную конструкцию, стеклянные рамы и переднюю зону стойки.',
  'airender.ex.architecture.3': 'Мебельный шоурум на современной улице. Фасад выходит на главную дорогу, впереди широкий тротуар, городская зелень и несколько припаркованных у обочины машин. По обеим сторонам — современные малоэтажные здания. Пространство должно быть чистым, премиальным и подходящим для коммерческой презентации.',
  'airender.ex.architecture.4': 'Деревянный дом для отдыха у озера, в окружении зелени, мощёных камнем дорожек и небольшого двора впереди. Позади — лёгкий лес и водная гладь, отражающая свет. Сохраните исходную архитектурную массу, крышу, деревянные материалы и пропорции сооружения.',
  'airender.opt.environment.other': 'Другое',
  'airender.opt.material.keep': 'Как в исходном изображении',
  'airender.opt.material.wood': 'Дерево',
  'airender.opt.material.glass': 'Стекло',
  'airender.opt.material.stone': 'Камень',
  'airender.opt.material.brick': 'Кирпич',
  'airender.opt.material.marble': 'Мрамор',
  'airender.opt.material.aluminum-glass': 'Алюминий и стекло',
  'airender.opt.material.ceramic': 'Керамика',
  'airender.opt.material.bamboo-rattan': 'Бамбук / Ротанг',
  'airender.opt.material.composite-panel': 'Композитная панель',
  'airender.opt.material.laterite': 'Латерит',
  'airender.opt.material.concrete': 'Бетон',
};

// ⚠ zh: NHÁP máy-dịch — chờ người bản ngữ duyệt.
const zh: Dict = {
  'app.loading': '正在加载模型…',
  'app.noToken': '链接中未找到模型代码。',
  'app.retry': '重试',
  'err.private.title': '私密模型',
  'err.private.body': '此模型为私密状态。需要所有者提供的 Author 链接才能查看。',
  'err.notfound.title': '未找到模型',
  'err.notfound.body': '链接不存在或已过期。请与发送者核对链接。',
  'err.version.title': '需要更新查看器',
  'err.version.body': '模型使用的格式比当前查看器更新。请稍后再试。',
  'err.empty.title': '空模型',
  'err.empty.body': '此模型没有可显示的零件。',
  'err.network.title': '无法加载模型',
  'err.network.body': '连接出错。请检查网络后重试。',
  'err.webgl.title': '无法显示 3D 模型',
  'err.webgl.body':
    '此设备的浏览器未启用硬件加速（WebGL）。请在浏览器设置中开启"使用硬件加速"并重启浏览器，更新显卡驱动，或改用其他浏览器。如果您通过远程桌面或虚拟机访问，请在带显卡的设备上直接打开链接。',

  'parts.count.other': '${n} 个零件',

  'side.title': '模型零件',
  'common.share': '分享',
  'common.close': '关闭',
  'common.overview': '总览',
  'common.zoomSelected': '缩放到所选零件',
  'author.editBadge': '编辑模式',
  'author.lockedBadge': '已锁定 — 无法保存',

  'ctx.open': '打开',
  'ctx.close': '关闭',
  'ctx.hide': '隐藏零件',
  'ctx.isolate': '隐藏其他零件',

  'toast.locked': '模型已锁定，无法更新',
  'toast.saved': '更改已保存',
  'toast.badEditLink': '编辑链接无效',
  'toast.saveFailed': '保存失败 — 请重试',
  'toast.copiedLink': '已复制链接',
  'toast.copiedEmbed': '已复制嵌入代码',

  'tb.material': '材质',
  'tb.matedge': '材质+边线',
  'tb.wireframe': '线框',
  'tb.wireframeHidden': '线框+隐藏线',
  'tb.xray': 'X 光',
  'tb.projection': '投影',
  'tb.viewIso': '透视',
  'tb.viewFront': '前面',
  'tb.viewLeft': '左面',
  'tb.viewRight': '右面',
  'tb.viewTop': '顶面',
  'tb.fit': '适配视图',
  'tb.openAll': '全部打开',
  'tb.closeAll': '全部关闭',
  'tb.fullscreen': '全屏',
  'tb.measure': '测量',
  'tb.lighting': '照明',
  'tb.dimensions': '尺寸',
  'explode.title': '爆炸视图',
  'explode.amount': '分离程度',
  'list.selectGroup': '选择组',
  'list.selectAll': '选择所有组',
  'sel.count': '已选 ${n} 个组',
  'sel.part': '已选零件',
  'sel.hidden': '已隐藏零件',
  'sel.explode': '爆炸',
  'sel.hide': '隐藏组',
  'sel.hideOthers': '隐藏其余',
  'sel.labels': '标注',
  'sel.clear': '清除',
  'tb.toolbar': '查看工具',
  'tb.modeGroup': '显示模式',
  'tb.viewGroup': '视角',

  'list.search': '搜索零件…',
  'list.scan': '扫描零件码',
  'list.empty': '未找到匹配的零件。',
  'list.moduleOther': '其他',
  'list.codePrefix': '编号 ${code}',
  'list.toggleMotion': '打开 / 关闭',
  'list.show': '显示零件',
  'list.hide': '隐藏零件',
  'list.showGroup': '显示整组',
  'list.hideGroup': '隐藏整组',
  'list.showAll': '全部显示',
  'list.collapse': '折叠分组',
  'list.expand': '展开分组',
  'list.collapseAll': '全部折叠',
  'list.expandAll': '全部展开',

  'info.selecting': '已选择',
  'info.code': '零件编号',
  'info.dims': '尺寸',
  'info.material': '材质',
  'info.motion': '运动',

  'motion.0': '固定',
  'motion.2': '右铰门',
  'motion.3': '左铰门',
  'motion.4': '下翻门',
  'motion.5': '上掀门',
  'motion.6': '左移门',
  'motion.7': '右移门',
  'motion.8': '抽屉箱体',
  'motion.11': '抽屉面板',
  'motion.12': 'Aventos HS（弧形上掀）',
  'motion.13': '气撑（直线上掀）',
  'motion.14': 'Aventos HF（双折）',
  'motion.15': '深抽（Z）',

  'author.motionTitle': '运动设置',
  'author.lockedBanner': '模型已锁定更新 — 无法保存',
  'author.selectPart': '在模型上选择一个零件以指定其打开方式。',
  'author.assigningTo': '正在指定给：',
  'author.catDoor': '门',
  'author.catDrawer': '抽屉',
  'author.catAdvanced': '高级',
  'author.groupRel': '运动协调',
  'author.groupRelHint': '默认每个部件单独运动。仅当多个部件需要一起运动时才合并（例如把手+门，抽屉面板+箱体）。',
  'author.relIndependent': '单独运动',
  'author.relIndependentSub': '独立运动',
  'author.relMergeWith': '一起运动',
  'author.groupShort': '组',
  'author.catOptions': '选项',
  'author.mHingeL': '左铰链',
  'author.mHingeR': '右铰链',
  'author.mLiftDown': '下翻',
  'author.mLiftUp': '上掀',
  'author.mSlideL': '左移',
  'author.mSlideR': '右移',
  'author.mDrawerBody': '抽屉箱体',
  'author.mDrawerFront': '抽屉面板',
  'author.mAventosHS': 'Aventos HS',
  'author.mAventosHF': 'Blum 上翻门',
  'author.mPiston': '气撑',
  'author.mDeepSlide': '深抽',
  'author.flip': '翻转',
  'author.flipHint': '切换铰链侧（左/右）。',
  'author.swingOut': '开门方向（里/外）',
  'author.swingOutHint': '门朝柜体内部翻开？点击切换向里/向外方向（与左右铰链无关）。',
  'author.clearAssign': '取消指定',
  'author.save': '保存更改',
  'author.saving': '正在保存…',
  'author.lightTitle': '照明',
  'author.lightApplyAll': '点击“保存更改”后对所有查看者生效。',
  'author.lightOnState': '照明已开启',
  'author.lightOffState': '已关闭 — 平面显示',
  'author.lightOnHint': '点击以关闭效果：模型平面显示（完整颜色 + 纹理），但无阴影、高光和立体感 — 不会变暗。',
  'author.lightOffHint': '点击以开启：按所选照明恢复立体感、阴影和亮度。',
  'author.lightKind': '照明类型',
  'author.lightEven': '均匀',
  'author.lightStudio': '影棚',
  'author.lightBright': '更亮',
  'author.lightEvenHint': '光来自多个方向，没有面会发暗；颜色和纹理在任何角度都清晰可读，阴影柔和。适合查看细节。',
  'author.lightStudioHint': '三点布光带来立体感、层次和清晰阴影，对比度高。适合展示 / 拍摄产品。',
  'author.lightBrightHint': '提高整体环境光并减少暗区，使整个模型更亮更均匀。适合深色材质 / 颜色。',
  'author.lightIntensity': '亮度',
  'author.lightIntensityHint': '50 = 所选类型的标准 · 100 = 两倍亮度 · 0 = 暗。',

  'measure.title': '测量',
  'measure.total': '整体',
  'measure.inner': '内净',
  'measure.manual': '手动',
  'measure.clear': '清除',
  'measure.manualHint': '在模型上点击 2 个点以测量距离。',
  'measure.innerHint': '点击 2 块同向板件 — 在模型上或列表中。',
  'measure.distance': '距离 = ${mm} mm',
  'measure.point1': '已标记第 1 点 — 点击第 2 点。',
  'measure.innerPick': '点击第 ${n} 块板',
  'measure.innerPick2': '点击第 2 块平行板件（侧板 / 层板 / 门板 / 背板）',
  'measure.innerSameDir': '请选择 2 块平行板件',
  'measure.innerResult': '内净 = ${mm} mm',
  'measure.innerGapResult': '缝隙 = ${mm} mm',
  'measure.innerOverlap': '2 块板件重叠 — 没有可测量的间隙',
  'measure.innerNoDir': '无法确定板件方向（弯板或斜放板）',
  'measure.innerRotateHint': '↻ 旋转视角以查看尺寸线',

  'hints.title': '操作提示',
  'hints.rotate': '单指：旋转模型',
  'hints.pan': '双指：平移和缩放',
  'hints.dblTap': '双击：打开/关闭柜门和抽屉',
  'hints.ok': '知道了',

  'scan.title': '扫描零件码',
  'scan.opening': '正在打开相机…',
  'scan.aim': '将零件的二维码对准取景框',
  'scan.zoom': '放大标签',
  'scan.badFormat': '代码 "${text}" 格式不正确。请扫描其他代码。',
  'scan.notFound': '未找到匹配代码 "${text}" 的零件。',
  'scan.noSupport': '浏览器不支持相机（需要 HTTPS 或 localhost）。',
  'scan.noAccess': '无法访问相机。请授予相机权限（需要 HTTPS 或 localhost）后重试。',

  'share.title': '分享模型',
  'share.qrFallback': '二维码需要连接服务器',
  'share.copyLink': '复制链接',
  'share.embedLabel': '嵌入代码 (iframe)',
  'share.copyEmbed': '复制嵌入代码',

  'lang.label': '语言',

  // ----- AI Render (04a) — 机器翻译草稿，待母语者校对 -----
  'airender.title': 'AI 渲染',
  'airender.open': 'AI 渲染 ✨',
  'airender.generate': '生成图像',
  'airender.generating': '生成中…',
  'airender.fieldRenderType': '渲染类型',
  'airender.fieldLighting': '光照',
  'airender.fieldViewAngle': '视角',
  'airender.fieldEnvironment': '环境',
  'airender.fieldColorTone': '色调',
  'airender.fieldAspect': '宽高比',
  'airender.fieldModel': 'AI 模型',
  'airender.fieldDescription': '描述',
  'airender.fieldCreativity': '创意度',
  'airender.descPlaceholder': '补充你想要的场景细节…',
  'airender.fieldMaterials': '材质',
  'airender.fieldNegative': '负面提示词',
  'airender.negativePlaceholder': '不想要的物体、变形…',
  'airender.fieldEnvironmentText': '其他环境',
  'airender.fieldLightingText': '其他光照',
  'airender.lightingTextPlaceholder': '描述自定义光照…',
  'airender.fieldSize': '尺寸',
  'airender.sizeNote': '尺寸 = 所截取底图的分辨率；画面比例决定 AI 输出。',
  'airender.opt.size.1024x1024': '正方形 (1024×1024)',
  'airender.opt.size.1080x1080': '社交正方形 (1080×1080)',
  'airender.opt.size.1536x1024': '横向 (1536×1024)',
  'airender.opt.size.1024x1536': '纵向 (1024×1536)',
  'airender.opt.size.1920x1080': 'Full HD 横向 (1920×1080)',
  'airender.opt.size.1080x1920': 'Full HD 纵向 (1080×1920)',
  'airender.opt.size.1280x720': 'HD 横向 (1280×720)',
  'airender.opt.size.2048x2048': '大正方形 (2048×2048)',
  // v3 (10e/04f): 两档创意 + 自动生成房间
  'airender.fieldLockGeometry': '保持3D模型不变',
  'airender.lockOnHint': '按3D模型锁定形体（附带结构参考图）——AI只改材质/场景，不改形状。',
  'airender.lockOffHint': '允许AI重新构想形体（旧模式，使用“保留设计”滑块）。',
  'airender.fieldPreserveFurniture': '保留柜体设计',
  'airender.fieldContextCreativity': '背景创意度',
  'airender.creativityNote':
    '"保留柜体设计"越高越贴合原柜体几何/比例；"背景创意度"越高房间/场景越精细。',
  'airender.roomSection': '自动生成房间空间',
  'airender.fieldRoomSource': '房间来源',
  'airender.fieldWall': '墙面',
  'airender.fieldFloor': '地面',
  'airender.fieldCeiling': '天花',
  'airender.fieldBacksplash': '防溅墙',
  'airender.fieldIsland': '中岛',
  'airender.fieldAccessory': '装饰',
  'airender.roomNote': '此部分仅用于室内。',
  'airender.opt.roomSource.ai-generated': 'AI 生成房间',
  'airender.opt.roomSource.use-existing': '使用模型中现有房间',
  'airender.opt.wall.auto': '自动',
  'airender.opt.wall.light-warm': '暖色明亮',
  'airender.opt.wall.matte-white': '哑光白',
  'airender.opt.wall.soft-concrete': '柔和混凝土',
  'airender.opt.wall.marble-accent': '大理石点缀',
  'airender.opt.wall.wood-accent': '木质点缀',
  'airender.opt.floor.auto': '自动',
  'airender.opt.floor.light-tiles': '浅色瓷砖',
  'airender.opt.floor.warm-wood': '暖色木地板',
  'airender.opt.floor.light-stone': '浅色石材',
  'airender.opt.floor.matte-concrete': '哑光混凝土',
  'airender.opt.ceiling.auto': '自动',
  'airender.opt.ceiling.recessed-spotlights': '嵌入式射灯',
  'airender.opt.ceiling.linear-led': '线性 LED',
  'airender.opt.ceiling.pendant-island': '中岛吊灯',
  'airender.opt.ceiling.minimal-flat': '极简平顶',
  'airender.opt.backsplash.auto': '自动',
  'airender.opt.backsplash.light-stone': '浅色石材',
  'airender.opt.backsplash.white-tile': '白色瓷砖',
  'airender.opt.backsplash.marble-slab': '大理石板',
  'airender.opt.backsplash.warm-gray': '暖灰',
  'airender.opt.backsplash.none': '无',
  'airender.opt.island.none': '无',
  'airender.opt.island.one': '一个中岛',
  'airender.opt.island.auto': '自动',
  'airender.opt.accessory.none': '无',
  'airender.opt.accessory.low': '少',
  'airender.opt.accessory.medium': '适中',
  'airender.opt.accessory.high': '多',
  'airender.environmentTextPlaceholder': '描述你想要的环境…',
  'airender.noModels': '暂无可用的 AI 模型',
  'airender.modelNoKey': '无密钥',
  'airender.noKey': '你尚未为该提供商输入 API 密钥。',
  'airender.openConsole': '打开控制台',
  'airender.viewAngleNote': '视角由 AI 在图像中重新演绎——不会旋转 3D 模型。',
  'airender.statusQueued': '排队中…',
  'airender.statusRunning': '渲染中…',
  'airender.failed': '渲染失败',
  'airender.errGeneric': '出错了——请重试',
  'airender.errCap': '已达到该模型的图像上限',
  'airender.errQuota': '超出账户存储空间',
  'airender.resultHint': '调整好画面，然后点击“生成图像”。',
  'airender.savedCount': '已保存：${n}',
  'airender.save': '保存',
  'airender.savedBadge': '已保存',
  'airender.download': '下载',
  'airender.setThumbnail': '设为缩略图',
  'airender.delete': '删除',
  'airender.toastSaved': '已保存渲染图',
  'airender.toastDeleted': '已删除渲染图',
  'airender.toastThumbnail': '已设为缩略图',
  'airender.galleryBtn': '渲染图',
  'airender.galleryTitle': 'AI 渲染图',
  'airender.galleryEmpty': '暂无已保存的渲染图。',
  'airender.prevImage': '上一张',
  'airender.nextImage': '下一张',
  'airender.opt.renderType.architecture': '建筑',
  'airender.opt.renderType.landscape': '景观',
  'airender.opt.renderType.interior': '室内',
  'airender.opt.lighting.overcast': '阴天',
  'airender.opt.lighting.natural': '自然光',
  'airender.opt.lighting.sunny': '晴天',
  'airender.opt.lighting.interior-lights': '室内灯光',
  'airender.opt.lighting.evening-interior': '傍晚（室内）',
  'airender.opt.lighting.dark-interior': '昏暗（室内）',
  'airender.opt.lighting.studio': '影棚',
  'airender.opt.lighting.dappled-interior': '斑驳光影（室内）',
  'airender.opt.lighting.golden-hour': '黄金时刻',
  'airender.opt.lighting.indirect-led': '间接 LED',
  'airender.opt.lighting.other': '其他',
  'airender.opt.viewAngle.keep': '保持当前',
  'airender.opt.viewAngle.front': '正面',
  'airender.opt.viewAngle.wide': '广角',
  'airender.opt.viewAngle.drone': '高空俯视（无人机）',
  'airender.opt.viewAngle.three-quarter-left': '左侧四分之三',
  'airender.opt.viewAngle.three-quarter-right': '右侧四分之三',
  'airender.opt.viewAngle.low': '低角度',
  'airender.opt.viewAngle.high': '高角度',
  'airender.opt.environment.urban': '城市',
  'airender.opt.environment.street': '街道',
  'airender.opt.environment.village': '乡村',
  'airender.opt.environment.countryside': '田园',
  'airender.opt.environment.living-room': '客厅',
  'airender.opt.environment.bedroom': '卧室',
  'airender.opt.environment.kitchen': '厨房',
  'airender.opt.colorTone.natural': '自然',
  'airender.opt.colorTone.warm': '暖色',
  'airender.opt.colorTone.cool-modern': '冷调现代',
  'airender.opt.colorTone.bw': '黑白',
  'airender.opt.colorTone.vintage-retro': '复古怀旧',
  'airender.opt.colorTone.pastel': '柔和粉彩',
  'airender.opt.colorTone.cinematic': '电影感',
  'airender.opt.colorTone.modern-warm': '现代暖调',
  'airender.opt.colorTone.luxury': '奢华高端',
  'airender.opt.colorTone.japandi': '日式极简',
  'airender.opt.colorTone.premium-apartment': '高端公寓',
  'airender.opt.colorTone.kitchen-showroom': '厨房展厅',
  'airender.opt.colorTone.scandinavian': '北欧轻盈',
  // AI 模型分级标签 (04h)
  'airender.opt.quality.very-high': '画质极高',
  'airender.opt.quality.high': '画质高',
  'airender.opt.quality.fair': '画质中等',
  'airender.opt.price.very-expensive': '价格很贵',
  'airender.opt.price.expensive': '价格贵',
  'airender.opt.price.medium': '价格中等',
  'airender.opt.price.cheap': '价格便宜',
  'airender.opt.speed.fast': '渲染快',
  'airender.opt.speed.medium': '渲染中等',
  'airender.opt.speed.slow': '渲染慢',
  'airender.opt.modelTag.new': '新',
  // 输入提示 + 示例提示词 (04h)
  'airender.fillExample': '自动填入示例',
  // 室外场景 (10f/04g)
  'airender.archSection': '建筑场景',
  'airender.landSection': '景观场景',
  'airender.fieldScene': '场景',
  'airender.fieldArchSurrounding': '周边建筑',
  'airender.fieldArchActivity': '人车活动',
  'airender.fieldArchGround': '地面',
  'airender.fieldSky': '天空',
  'airender.fieldLandTerrain': '地形',
  'airender.fieldLandWater': '水景',
  'airender.fieldLandHeroTree': '主景树',
  'airender.fieldLandGround': '地面',
  'airender.sceneVsEnvNote': '当下方选择"场景"（非自动）时，它将取代"环境"。"环境"仅在"场景"为自动时使用，或选"其他"自由描述。',
  'airender.opt.archScene.auto': '自动',
  'airender.opt.archScene.urban-heritage-street': '城市历史街区',
  'airender.opt.archScene.old-town': '老城区',
  'airender.opt.archScene.modern-city': '现代都市',
  'airender.opt.archScene.tourist-street': '旅游街道',
  'airender.opt.archScene.garden-courtyard': '庭院花园',
  'airender.opt.archSurrounding.auto': '自动',
  'airender.opt.archSurrounding.low-rise-nearby': '近处低层建筑',
  'airender.opt.archSurrounding.high-rise-far': '远处高层',
  'airender.opt.archSurrounding.mixed': '混合',
  'airender.opt.archSurrounding.none': '无',
  'airender.opt.archActivity.auto': '自动',
  'airender.opt.archActivity.none': '无',
  'airender.opt.archActivity.light': '稀少',
  'airender.opt.archActivity.medium': '适中',
  'airender.opt.archActivity.busy': '繁忙',
  'airender.opt.archGround.auto': '自动',
  'airender.opt.archGround.stone-pavement': '石板路面',
  'airender.opt.archGround.sidewalk': '人行道',
  'airender.opt.archGround.asphalt': '沥青路',
  'airender.opt.sky.auto': '自动',
  'airender.opt.sky.golden-hour': '黄金时刻',
  'airender.opt.sky.daylight': '日间',
  'airender.opt.sky.clear': '晴空',
  'airender.opt.sky.overcast': '阴天',
  'airender.opt.sky.night': '夜晚',
  'airender.opt.landScene.auto': '自动',
  'airender.opt.landScene.forest': '森林',
  'airender.opt.landScene.streamside': '溪边',
  'airender.opt.landScene.mountain': '山地',
  'airender.opt.landScene.japanese-garden': '日式庭园',
  'airender.opt.landScene.park': '公园',
  'airender.opt.landScene.old-village': '古村落',
  'airender.opt.landScene.lakeside': '湖畔',
  'airender.opt.landTerrain.auto': '自动',
  'airender.opt.landTerrain.forest-clearing': '林间空地',
  'airender.opt.landTerrain.gentle-hill': '缓坡',
  'airender.opt.landTerrain.streamside': '溪边',
  'airender.opt.landTerrain.rocky': '多岩石',
  'airender.opt.landTerrain.paved-path': '石铺小径',
  'airender.opt.landWater.auto': '自动',
  'airender.opt.landWater.none': '无',
  'airender.opt.landWater.stream-beside': '旁边溪流',
  'airender.opt.landWater.stream-front': '前方溪流',
  'airender.opt.landWater.pond-front': '前方池塘',
  'airender.opt.landWater.waterfall-back': '后方瀑布',
  'airender.opt.landHeroTree.auto': '自动',
  'airender.opt.landHeroTree.none': '无',
  'airender.opt.landHeroTree.ancient-pine-behind': '后方古松',
  'airender.opt.landHeroTree.red-maple': '红枫',
  'airender.opt.landHeroTree.bamboo': '竹',
  'airender.opt.landHeroTree.natural-forest': '自然林',
  'airender.opt.landGround.auto': '自动',
  'airender.opt.landGround.stone-and-moss': '石与苔',
  'airender.opt.landGround.grass': '草地',
  'airender.opt.landGround.dirt': '泥土地',
  'airender.hint.renderType': '选择要生成的图像类型：室内房间、建筑作品，或室外景观。',
  'airender.hint.environment': '产品周围的环境/房间类型（如客厅、街道）。选"其他"可自行输入。',
  'airender.hint.lighting': '画面的光照风格——可选 0 个或多个；留空 = 由 AI 决定。',
  'airender.hint.colorTone': '整体色调/配色风格——可选 0 个或多个；留空 = 由 AI 决定。',
  'airender.hint.materials': '希望在画面中突出的材质——可多选；"保持原样"= 沿用原始材质。',
  'airender.hint.model': '选择用于渲染的 AI 模型（来自你已填入密钥的服务商）。',
  'airender.hint.negative': '列出你不希望出现的元素（如：人物、文字、变形）。',
  'airender.hint.desc.interior': '请描述房间类型、家具如何贴合墙面/地面/天花、需要添加的设备、装饰物、空间氛围，以及必须保留的细节。',
  'airender.hint.desc.architecture': '请描述建筑、周围环境、场景中的活动、主要材质，以及不能破坏原始设计的细节。',
  'airender.hint.desc.landscape': '请描述地形、植被、水体、岩石、地面、背景，以及主体在场景中的位置。请说明哪些元素在主体前方、旁边或后方。',
  'airender.ex.interior.1': '现代开放式厨房，大面积玻璃墙带来充沛自然光。木质橱柜系统完美贴墙安装，台面铺设云纹石英石。安装有抽油烟机。台面上点缀一盆小绿植、一篮新鲜水果、一台意式浓缩咖啡机和一台 KitchenAid 厨师机。冰箱旁立着一盆又大又漂亮的龟背竹。一位越南家庭主妇正看着饭菜。一个越南宝宝抱着妈妈的腿。岛台上摆着一盘丰盛美味的食物。',
  'airender.ex.interior.2': '橱柜固定安装在厨房两面垂直的墙上。柜内含抽油烟机、烤箱和嵌入式微波炉。台面上有电磁炉、一盆小绿植和一台 KitchenAid 厨师机。房间中央有一座与石材台面相配的中岛。空间需温暖、整洁、高级，且不堆砌过多装饰。',
  'airender.ex.interior.3': '电视柜紧贴客厅主墙安装。周围为浅色墙面、温暖木地板，前方有一张低矮沙发和一张小茶几。柜上摆放少量轻巧装饰、一盆小绿植，配柔和的墙面洗光。空间需现代、整洁、奢华，并保留原始电视柜设计。',
  'airender.ex.interior.4': '衣柜紧贴卧室墙面摆放，旁边有一张小梳妆台和镜子。房间有低矮床、浅色窗帘、木地板和柔和暖光。空间需温暖、放松、整洁且高级。需保留衣柜系统的原始布局、比例和主要材质。',
  'airender.ex.landscape.1': '一座传统木结构休憩亭坐落于葱郁的热带生态花园中。建筑稳稳立于碎石地面与天然巨石之上，四周环绕蕨类灌丛与青苔石块。旁边有一条潺潺小溪。灿烂的金色夕阳穿过叶隙，在瓦屋顶上投下柔和的影子。',
  'airender.ex.landscape.2': '木结构寺庙坐落于一片静谧的林间。寺旁有一条小溪流过，前方有天然岩石与青苔。寺后是一棵高大的古松，四周是茂密但不遮挡建筑的绿林。氛围宁静、自然且富有层次。',
  'airender.ex.landscape.3': '凉亭坐落于宽阔的公园中央。四周是草坪、石铺步道、低矮绿植，背景有几棵大树。前方有开阔场地以便看清整座建筑。景观需明亮、通透、自然，适合户外建筑展示图。',
  'airender.ex.landscape.4': '建筑坐落于平缓的山坡上，远眺绿色山谷。四周有草地、天然岩石、低矮灌木和几棵大树。背景有淡淡的薄雾山影与清澈天空。主体需突出，不被植被遮挡。',
  'airender.ex.architecture.1': '一座传统东方风格的木质摊亭，醒目地坐落于熙攘的石铺步行街上。周围是成排的现代联排住宅，远处街灯朦胧。暮色苍茫。嵌入式 LED 顶灯洒下柔和暖光照在路面上，完美融合古典建筑与都市生活节奏。',
  'airender.ex.architecture.2': '一家古风咖啡馆位于热闹街区的转角。附近有几栋低层房屋，远处是现代高楼。店前是石铺人行道，后方有几位行人和车辆，但不遮挡店面。建筑需清晰保留弧形屋顶、木结构、玻璃窗框及前方吧台区域。',
  'airender.ex.architecture.3': '家具展厅位于现代街道上。立面朝向主干道，前方有宽阔人行道、城市绿化和几辆停在路边的车。两侧是现代低层建筑。空间需整洁、高级，适合做商业展示图。',
  'airender.ex.architecture.4': '一座临湖的木质度假屋，四周环绕绿植、石铺步道和前方小院。屋后是疏朗林木与映光水面。需保留建筑的原始体量、屋顶、木质材料和比例。',
  'airender.opt.environment.other': '其他',
  'airender.opt.material.keep': '保持原图材质',
  'airender.opt.material.wood': '木材',
  'airender.opt.material.glass': '玻璃',
  'airender.opt.material.stone': '石材',
  'airender.opt.material.brick': '砖',
  'airender.opt.material.marble': '大理石',
  'airender.opt.material.aluminum-glass': '铝合金玻璃',
  'airender.opt.material.ceramic': '陶瓷',
  'airender.opt.material.bamboo-rattan': '竹 / 藤',
  'airender.opt.material.composite-panel': '复合板',
  'airender.opt.material.laterite': '红土石',
  'airender.opt.material.concrete': '混凝土',
};

// ⚠ th: NHÁP máy-dịch — chờ người bản ngữ duyệt.
const th: Dict = {
  'app.loading': 'กำลังโหลดโมเดล…',
  'app.noToken': 'ไม่พบรหัสโมเดลในลิงก์',
  'app.retry': 'ลองใหม่',
  'err.private.title': 'โมเดลส่วนตัว',
  'err.private.body': 'โมเดลนี้เป็นแบบส่วนตัว ต้องใช้ลิงก์ Author จากเจ้าของจึงจะดูได้',
  'err.notfound.title': 'ไม่พบโมเดล',
  'err.notfound.body': 'ลิงก์ไม่มีอยู่หรือหมดอายุแล้ว กรุณาตรวจสอบลิงก์กับผู้ส่ง',
  'err.version.title': 'ต้องอัปเดตโปรแกรมดู',
  'err.version.body': 'โมเดลใช้รูปแบบที่ใหม่กว่าโปรแกรมดูปัจจุบัน กรุณาลองใหม่ภายหลัง',
  'err.empty.title': 'โมเดลว่าง',
  'err.empty.body': 'โมเดลนี้ยังไม่มีชิ้นส่วนให้แสดง',
  'err.network.title': 'โหลดโมเดลไม่ได้',
  'err.network.body': 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาตรวจสอบเครือข่ายแล้วลองใหม่',
  'err.webgl.title': 'ไม่สามารถแสดงโมเดล 3 มิติได้',
  'err.webgl.body':
    'เบราว์เซอร์บนเครื่องนี้ยังไม่ได้เปิดใช้การเร่งด้วยฮาร์ดแวร์ (WebGL) กรุณาเปิด "ใช้การเร่งด้วยฮาร์ดแวร์" ในการตั้งค่าเบราว์เซอร์แล้วรีสตาร์ท อัปเดตไดรเวอร์การ์ดจอ หรือลองใช้เบราว์เซอร์อื่น หากคุณใช้งานผ่าน Remote Desktop หรือเครื่องเสมือน กรุณาเปิดลิงก์โดยตรงบนอุปกรณ์ที่มีการ์ดจอ',

  'parts.count.other': '${n} ชิ้นส่วน',

  'side.title': 'ชิ้นส่วนของโมเดล',
  'common.share': 'แชร์',
  'common.close': 'ปิด',
  'common.overview': 'ภาพรวม',
  'common.zoomSelected': 'ซูมไปที่ชิ้นที่เลือก',
  'author.editBadge': 'โหมดแก้ไข',
  'author.lockedBadge': 'ถูกล็อก — บันทึกไม่ได้',

  'ctx.open': 'เปิด',
  'ctx.close': 'ปิด',
  'ctx.hide': 'ซ่อนชิ้นส่วน',
  'ctx.isolate': 'ซ่อนชิ้นอื่น',

  'toast.locked': 'โมเดลถูกล็อกไม่ให้อัปเดต',
  'toast.saved': 'บันทึกการเปลี่ยนแปลงแล้ว',
  'toast.badEditLink': 'ลิงก์แก้ไขไม่ถูกต้อง',
  'toast.saveFailed': 'บันทึกไม่สำเร็จ — ลองใหม่',
  'toast.copiedLink': 'คัดลอกลิงก์แล้ว',
  'toast.copiedEmbed': 'คัดลอกโค้ดฝังแล้ว',

  'tb.material': 'วัสดุ',
  'tb.matedge': 'วัสดุ+เส้นขอบ',
  'tb.wireframe': 'โครงลวด',
  'tb.wireframeHidden': 'โครงลวด+เส้นซ่อน',
  'tb.xray': 'เอกซเรย์',
  'tb.projection': 'ภาพฉาย',
  'tb.viewIso': 'เพอร์สเปกทีฟ',
  'tb.viewFront': 'ด้านหน้า',
  'tb.viewLeft': 'ด้านซ้าย',
  'tb.viewRight': 'ด้านขวา',
  'tb.viewTop': 'ด้านบน',
  'tb.fit': 'พอดีกรอบ',
  'tb.openAll': 'เปิดทั้งหมด',
  'tb.closeAll': 'ปิดทั้งหมด',
  'tb.fullscreen': 'เต็มจอ',
  'tb.measure': 'วัด',
  'tb.lighting': 'แสง',
  'tb.dimensions': 'ขนาด',
  'explode.title': 'มุมมองแยกชิ้น',
  'explode.amount': 'ระดับการแยก',
  'list.selectGroup': 'เลือกกลุ่ม',
  'list.selectAll': 'เลือกทุกกลุ่ม',
  'sel.count': 'เลือก ${n} กลุ่ม',
  'sel.part': 'ชิ้นส่วนที่เลือก',
  'sel.hidden': 'ซ่อนชิ้นส่วนอยู่',
  'sel.explode': 'แยกชิ้น',
  'sel.hide': 'ซ่อนกลุ่ม',
  'sel.hideOthers': 'ซ่อนส่วนอื่น',
  'sel.labels': 'ป้ายกำกับ',
  'sel.clear': 'ล้าง',
  'tb.toolbar': 'เครื่องมือดู',
  'tb.modeGroup': 'โหมดแสดงผล',
  'tb.viewGroup': 'มุมมอง',

  'list.search': 'ค้นหาชิ้นส่วน…',
  'list.scan': 'สแกนรหัสชิ้นส่วน',
  'list.empty': 'ไม่พบชิ้นส่วนที่ตรงกัน',
  'list.moduleOther': 'อื่น ๆ',
  'list.codePrefix': 'เลขที่ ${code}',
  'list.toggleMotion': 'เปิด / ปิด',
  'list.show': 'แสดงชิ้นส่วน',
  'list.hide': 'ซ่อนชิ้นส่วน',
  'list.showGroup': 'แสดงทั้งกลุ่ม',
  'list.hideGroup': 'ซ่อนทั้งกลุ่ม',
  'list.showAll': 'แสดงทั้งหมด',
  'list.collapse': 'ยุบกลุ่ม',
  'list.expand': 'ขยายกลุ่ม',
  'list.collapseAll': 'ยุบทั้งหมด',
  'list.expandAll': 'ขยายทั้งหมด',

  'info.selecting': 'กำลังเลือก',
  'info.code': 'เลขชิ้นส่วน',
  'info.dims': 'ขนาด',
  'info.material': 'วัสดุ',
  'info.motion': 'การเคลื่อนไหว',

  'motion.0': 'อยู่กับที่',
  'motion.2': 'บานพับขวา',
  'motion.3': 'บานพับซ้าย',
  'motion.4': 'บานพับลงล่าง',
  'motion.5': 'บานยกขึ้น',
  'motion.6': 'บานเลื่อนซ้าย',
  'motion.7': 'บานเลื่อนขวา',
  'motion.8': 'กล่องลิ้นชัก',
  'motion.11': 'หน้าบานลิ้นชัก',
  'motion.12': 'Aventos HS (ยกแบบโค้ง)',
  'motion.13': 'ลูกสูบ (ยกตรง)',
  'motion.14': 'Aventos HF (พับสองตอน)',
  'motion.15': 'เลื่อนลึก (Z)',

  'author.motionTitle': 'ตั้งค่าการเคลื่อนไหว',
  'author.lockedBanner': 'โมเดลถูกล็อกไม่ให้อัปเดต — บันทึกไม่ได้',
  'author.selectPart': 'เลือกชิ้นส่วนบนโมเดลเพื่อกำหนดวิธีเปิด',
  'author.assigningTo': 'กำลังกำหนดให้:',
  'author.catDoor': 'บานประตู',
  'author.catDrawer': 'ลิ้นชัก',
  'author.catAdvanced': 'ขั้นสูง',
  'author.groupRel': 'การประสานการเคลื่อนไหว',
  'author.groupRelHint': 'ค่าเริ่มต้นแต่ละชิ้นส่วนเคลื่อนไหวแยกกัน รวมกลุ่มเฉพาะเมื่อต้องการให้หลายชิ้นเคลื่อนไหวพร้อมกัน (เช่น มือจับ + บานประตู, หน้าลิ้นชัก + ตัวลิ้นชัก)',
  'author.relIndependent': 'เคลื่อนไหวเดี่ยว',
  'author.relIndependentSub': 'เคลื่อนไหวอิสระ',
  'author.relMergeWith': 'เคลื่อนไหวพร้อมกับ',
  'author.groupShort': 'กลุ่ม',
  'author.catOptions': 'ตัวเลือก',
  'author.mHingeL': 'บานพับซ้าย',
  'author.mHingeR': 'บานพับขวา',
  'author.mLiftDown': 'พับลง',
  'author.mLiftUp': 'ยกขึ้น',
  'author.mSlideL': 'เลื่อนซ้าย',
  'author.mSlideR': 'เลื่อนขวา',
  'author.mDrawerBody': 'กล่องลิ้นชัก',
  'author.mDrawerFront': 'หน้าบานลิ้นชัก',
  'author.mAventosHS': 'Aventos HS',
  'author.mAventosHF': 'บานยก Blum',
  'author.mPiston': 'ลูกสูบ',
  'author.mDeepSlide': 'เลื่อนลึก',
  'author.flip': 'กลับด้าน',
  'author.flipHint': 'สลับด้านบานพับ (ซ้าย/ขวา)',
  'author.swingOut': 'สลับทิศเปิด เข้า/ออก',
  'author.swingOutHint': 'บานเปิดเข้าไปในตัวตู้? กดสลับทิศเปิด เข้า/ออก (คนละอย่างกับบานพับซ้าย/ขวา)',
  'author.clearAssign': 'ยกเลิก',
  'author.save': 'บันทึกการเปลี่ยนแปลง',
  'author.saving': 'กำลังบันทึก…',
  'author.lightTitle': 'แสง',
  'author.lightApplyAll': 'มีผลกับผู้ชมทุกคนหลังกด “บันทึกการเปลี่ยนแปลง”',
  'author.lightOnState': 'เปิดแสงอยู่',
  'author.lightOffState': 'ปิด — แสดงแบบแบน',
  'author.lightOnHint': 'กดเพื่อปิดเอฟเฟกต์: โมเดลแสดงแบบแบน (สีและลายครบ) แต่ไม่มีเงา ไม่มีประกาย ไม่มีมิติ — ไม่มืดลง',
  'author.lightOffHint': 'กดเพื่อเปิด: คืนมิติ เงา และความสว่างตามแบบแสงที่เลือก',
  'author.lightKind': 'รูปแบบแสง',
  'author.lightEven': 'สม่ำเสมอ',
  'author.lightStudio': 'สตูดิโอ',
  'author.lightBright': 'สว่างขึ้น',
  'author.lightEvenHint': 'แสงมาจากหลายทิศ จึงไม่มีด้านใดมืด อ่านสีและลายได้ดีทุกมุม เงานุ่ม เหมาะสำหรับดูรายละเอียด',
  'author.lightStudioHint': 'การจัดไฟ 3 จุดให้มิติ ความลึก และเงาชัด คอนทราสต์สูง เหมาะสำหรับนำเสนอ / ถ่ายสินค้า',
  'author.lightBrightHint': 'เพิ่มแสงรวมโดยรวมและลดพื้นที่มืด ทำให้ทั้งโมเดลสว่างและสม่ำเสมอขึ้น เหมาะกับวัสดุ / สีเข้ม',
  'author.lightIntensity': 'ความสว่าง',
  'author.lightIntensityHint': '50 = มาตรฐานของรูปแบบที่เลือก · 100 = สว่างสองเท่า · 0 = มืด',

  'measure.title': 'วัดขนาด',
  'measure.total': 'ภาพรวม',
  'measure.inner': 'ระยะใน',
  'measure.manual': 'วัดเอง',
  'measure.clear': 'ล้าง',
  'measure.manualHint': 'คลิก 2 จุดบนโมเดลเพื่อวัดระยะ',
  'measure.innerHint': 'คลิกแผ่น 2 ชิ้นที่ขนานกัน — บนโมเดลหรือในรายการ',
  'measure.distance': 'ระยะ = ${mm} มม.',
  'measure.point1': 'จุดที่ 1 แล้ว — คลิกจุดที่ 2',
  'measure.innerPick': 'คลิกแผ่นที่ ${n}',
  'measure.innerPick2': 'คลิกแผ่นที่ 2 ที่ขนานกัน (แผงข้าง ชั้นวาง บานประตู แผ่นหลัง)',
  'measure.innerSameDir': 'กรุณาเลือกแผ่น 2 ชิ้นที่ขนานกัน',
  'measure.innerResult': 'ระยะใน = ${mm} มม.',
  'measure.innerGapResult': 'ช่องห่าง = ${mm} มม.',
  'measure.innerOverlap': 'แผ่น 2 ชิ้นซ้อนทับกัน — ไม่มีช่องว่างให้วัด',
  'measure.innerNoDir': 'ไม่สามารถระบุทิศทางของแผ่นได้ (แผ่นโค้งหรือวางเอียง)',
  'measure.innerRotateHint': '↻ หมุนมุมมองเพื่อดูเส้นบอกขนาด',

  'hints.title': 'เคล็ดลับการใช้งาน',
  'hints.rotate': '1 นิ้ว: หมุนโมเดล',
  'hints.pan': '2 นิ้ว: เลื่อนและซูม',
  'hints.dblTap': 'แตะสองครั้ง: เปิด/ปิดบานและลิ้นชัก',
  'hints.ok': 'เข้าใจแล้ว',

  'scan.title': 'สแกนรหัสชิ้นส่วน',
  'scan.opening': 'กำลังเปิดกล้อง…',
  'scan.aim': 'เล็งคิวอาร์โค้ดของชิ้นส่วนเข้ากรอบ',
  'scan.zoom': 'ซูมเข้าที่ป้าย',
  'scan.badFormat': 'รหัส "${text}" รูปแบบไม่ถูกต้อง กรุณาสแกนรหัสอื่น',
  'scan.notFound': 'ไม่พบชิ้นส่วนที่ตรงกับรหัส "${text}"',
  'scan.noSupport': 'เบราว์เซอร์ไม่รองรับกล้อง (ต้องใช้ HTTPS หรือ localhost)',
  'scan.noAccess': 'เข้าถึงกล้องไม่ได้ กรุณาอนุญาตการใช้กล้อง (ต้องใช้ HTTPS หรือ localhost) แล้วลองใหม่',

  'share.title': 'แชร์โมเดล',
  'share.qrFallback': 'คิวอาร์โค้ดต้องเชื่อมต่อเซิร์ฟเวอร์',
  'share.copyLink': 'คัดลอกลิงก์',
  'share.embedLabel': 'โค้ดฝัง (iframe)',
  'share.copyEmbed': 'คัดลอกโค้ดฝัง',

  'lang.label': 'ภาษา',

  // ----- AI Render (04a) — ฉบับร่างแปลด้วยเครื่อง รอเจ้าของภาษาตรวจ -----
  'airender.title': 'เรนเดอร์ AI',
  'airender.open': 'เรนเดอร์ AI ✨',
  'airender.generate': 'สร้างภาพ',
  'airender.generating': 'กำลังสร้าง…',
  'airender.fieldRenderType': 'ประเภทการเรนเดอร์',
  'airender.fieldLighting': 'แสง',
  'airender.fieldViewAngle': 'มุมมอง',
  'airender.fieldEnvironment': 'สภาพแวดล้อม',
  'airender.fieldColorTone': 'โทนสี',
  'airender.fieldAspect': 'อัตราส่วนภาพ',
  'airender.fieldModel': 'โมเดล AI',
  'airender.fieldDescription': 'คำอธิบาย',
  'airender.fieldCreativity': 'ความสร้างสรรค์',
  'airender.descPlaceholder': 'เพิ่มรายละเอียดฉากที่ต้องการ…',
  'airender.fieldMaterials': 'วัสดุ',
  'airender.fieldNegative': 'คำสั่งเชิงลบ',
  'airender.negativePlaceholder': 'วัตถุที่ไม่ต้องการ ความผิดเพี้ยน…',
  'airender.fieldEnvironmentText': 'สภาพแวดล้อมอื่น',
  'airender.fieldLightingText': 'แสงอื่น ๆ',
  'airender.lightingTextPlaceholder': 'อธิบายแสงที่ต้องการเอง…',
  'airender.fieldSize': 'ขนาด',
  'airender.sizeNote': 'ขนาด = ความละเอียดของภาพฉากที่จับ; สัดส่วนเฟรมกำหนดผลลัพธ์ AI',
  'airender.opt.size.1024x1024': 'จัตุรัส (1024×1024)',
  'airender.opt.size.1080x1080': 'จัตุรัสโซเชียล (1080×1080)',
  'airender.opt.size.1536x1024': 'แนวนอน (1536×1024)',
  'airender.opt.size.1024x1536': 'แนวตั้ง (1024×1536)',
  'airender.opt.size.1920x1080': 'Full HD แนวนอน (1920×1080)',
  'airender.opt.size.1080x1920': 'Full HD แนวตั้ง (1080×1920)',
  'airender.opt.size.1280x720': 'HD แนวนอน (1280×720)',
  'airender.opt.size.2048x2048': 'จัตุรัสใหญ่ (2048×2048)',
  // v3 (10e/04f): สองสเกลความสร้างสรรค์ + สร้างห้องอัตโนมัติ
  'airender.fieldLockGeometry': 'คงโมเดล 3 มิติ',
  'airender.lockOnHint':
    'ล็อกรูปทรงตามโมเดล 3 มิติ (ส่งภาพไกด์โครงสร้าง) — AI เปลี่ยนแค่วัสดุ/ฉาก ไม่เปลี่ยนรูปทรง',
  'airender.lockOffHint': 'ให้ AI สร้างรูปทรงใหม่ได้ (โหมดเดิม ใช้แถบ “คงดีไซน์”)',
  'airender.fieldPreserveFurniture': 'คงดีไซน์ตู้',
  'airender.fieldContextCreativity': 'ความสร้างสรรค์ของฉาก',
  'airender.creativityNote':
    '"คงดีไซน์ตู้" สูง = ยึดรูปทรง/สัดส่วนตู้เดิม; "ความสร้างสรรค์ของฉาก" สูง = ห้อง/ฉากละเอียดขึ้น',
  'airender.roomSection': 'สร้างพื้นที่ห้องอัตโนมัติ',
  'airender.fieldRoomSource': 'แหล่งห้อง',
  'airender.fieldWall': 'ผนัง',
  'airender.fieldFloor': 'พื้น',
  'airender.fieldCeiling': 'เพดาน',
  'airender.fieldBacksplash': 'แผงกันเปื้อน',
  'airender.fieldIsland': 'เกาะกลาง',
  'airender.fieldAccessory': 'ของตกแต่ง',
  'airender.roomNote': 'ส่วนนี้ใช้สำหรับงานภายในเท่านั้น',
  'airender.opt.roomSource.ai-generated': 'ห้องที่ AI สร้าง',
  'airender.opt.roomSource.use-existing': 'ใช้ห้องที่มีในโมเดล',
  'airender.opt.wall.auto': 'อัตโนมัติ',
  'airender.opt.wall.light-warm': 'สว่างโทนอุ่น',
  'airender.opt.wall.matte-white': 'ขาวด้าน',
  'airender.opt.wall.soft-concrete': 'คอนกรีตนุ่ม',
  'airender.opt.wall.marble-accent': 'เน้นหินอ่อน',
  'airender.opt.wall.wood-accent': 'เน้นไม้',
  'airender.opt.floor.auto': 'อัตโนมัติ',
  'airender.opt.floor.light-tiles': 'กระเบื้องสีอ่อน',
  'airender.opt.floor.warm-wood': 'ไม้โทนอุ่น',
  'airender.opt.floor.light-stone': 'หินสีอ่อน',
  'airender.opt.floor.matte-concrete': 'คอนกรีตด้าน',
  'airender.opt.ceiling.auto': 'อัตโนมัติ',
  'airender.opt.ceiling.recessed-spotlights': 'สปอตไลต์ฝังฝ้า',
  'airender.opt.ceiling.linear-led': 'LED เส้น',
  'airender.opt.ceiling.pendant-island': 'โคมแขวนเหนือเกาะ',
  'airender.opt.ceiling.minimal-flat': 'เรียบมินิมอล',
  'airender.opt.backsplash.auto': 'อัตโนมัติ',
  'airender.opt.backsplash.light-stone': 'หินสีอ่อน',
  'airender.opt.backsplash.white-tile': 'กระเบื้องขาว',
  'airender.opt.backsplash.marble-slab': 'แผ่นหินอ่อน',
  'airender.opt.backsplash.warm-gray': 'เทาโทนอุ่น',
  'airender.opt.backsplash.none': 'ไม่มี',
  'airender.opt.island.none': 'ไม่มี',
  'airender.opt.island.one': 'เกาะเดียว',
  'airender.opt.island.auto': 'อัตโนมัติ',
  'airender.opt.accessory.none': 'ไม่มี',
  'airender.opt.accessory.low': 'น้อย',
  'airender.opt.accessory.medium': 'ปานกลาง',
  'airender.opt.accessory.high': 'มาก',
  'airender.environmentTextPlaceholder': 'อธิบายสภาพแวดล้อมที่ต้องการ…',
  'airender.noModels': 'ยังไม่มีโมเดล AI ให้ใช้งาน',
  'airender.modelNoKey': 'ไม่มีคีย์',
  'airender.noKey': 'คุณยังไม่ได้กรอกคีย์ API สำหรับผู้ให้บริการนี้',
  'airender.openConsole': 'เปิดคอนโซล',
  'airender.viewAngleNote': 'มุมมองถูกตีความใหม่โดย AI ในภาพ — ไม่ได้หมุนโมเดล 3 มิติ',
  'airender.statusQueued': 'อยู่ในคิว…',
  'airender.statusRunning': 'กำลังเรนเดอร์…',
  'airender.failed': 'เรนเดอร์ล้มเหลว',
  'airender.errGeneric': 'เกิดข้อผิดพลาด — ลองอีกครั้ง',
  'airender.errCap': 'ถึงจำนวนภาพสูงสุดสำหรับโมเดลนี้แล้ว',
  'airender.errQuota': 'เกินพื้นที่จัดเก็บของบัญชี',
  'airender.resultHint': 'จัดฉากแล้วกด “สร้างภาพ” เพื่อเรนเดอร์',
  'airender.savedCount': 'บันทึกแล้ว: ${n}',
  'airender.save': 'บันทึก',
  'airender.savedBadge': 'บันทึกแล้ว',
  'airender.download': 'ดาวน์โหลด',
  'airender.setThumbnail': 'ตั้งเป็นภาพปก',
  'airender.delete': 'ลบ',
  'airender.toastSaved': 'บันทึกภาพเรนเดอร์แล้ว',
  'airender.toastDeleted': 'ลบภาพเรนเดอร์แล้ว',
  'airender.toastThumbnail': 'ตั้งเป็นภาพปกแล้ว',
  'airender.galleryBtn': 'ภาพเรนเดอร์',
  'airender.galleryTitle': 'ภาพเรนเดอร์ AI',
  'airender.galleryEmpty': 'ยังไม่มีภาพเรนเดอร์ที่บันทึกไว้',
  'airender.prevImage': 'ภาพก่อนหน้า',
  'airender.nextImage': 'ภาพถัดไป',
  'airender.opt.renderType.architecture': 'สถาปัตยกรรม',
  'airender.opt.renderType.landscape': 'ภูมิทัศน์',
  'airender.opt.renderType.interior': 'ภายใน',
  'airender.opt.lighting.overcast': 'ฟ้าครึ้ม',
  'airender.opt.lighting.natural': 'แสงธรรมชาติ',
  'airender.opt.lighting.sunny': 'แดดจัด',
  'airender.opt.lighting.interior-lights': 'ไฟภายใน',
  'airender.opt.lighting.evening-interior': 'ยามเย็น (ภายใน)',
  'airender.opt.lighting.dark-interior': 'มืด (ภายใน)',
  'airender.opt.lighting.studio': 'สตูดิโอ',
  'airender.opt.lighting.dappled-interior': 'แสงลายพร้อย (ภายใน)',
  'airender.opt.lighting.golden-hour': 'ช่วงแสงทอง',
  'airender.opt.lighting.indirect-led': 'LED ทางอ้อม',
  'airender.opt.lighting.other': 'อื่น ๆ',
  'airender.opt.viewAngle.keep': 'คงเดิม',
  'airender.opt.viewAngle.front': 'ด้านหน้า',
  'airender.opt.viewAngle.wide': 'มุมกว้าง',
  'airender.opt.viewAngle.drone': 'มุมสูง (โดรน)',
  'airender.opt.viewAngle.three-quarter-left': 'สามส่วนสี่ด้านซ้าย',
  'airender.opt.viewAngle.three-quarter-right': 'สามส่วนสี่ด้านขวา',
  'airender.opt.viewAngle.low': 'มุมต่ำ',
  'airender.opt.viewAngle.high': 'มุมสูง',
  'airender.opt.environment.urban': 'เมือง',
  'airender.opt.environment.street': 'ถนน',
  'airender.opt.environment.village': 'หมู่บ้าน',
  'airender.opt.environment.countryside': 'ชนบท',
  'airender.opt.environment.living-room': 'ห้องนั่งเล่น',
  'airender.opt.environment.bedroom': 'ห้องนอน',
  'airender.opt.environment.kitchen': 'ห้องครัว',
  'airender.opt.colorTone.natural': 'ธรรมชาติ',
  'airender.opt.colorTone.warm': 'โทนอุ่น',
  'airender.opt.colorTone.cool-modern': 'โทนเย็นโมเดิร์น',
  'airender.opt.colorTone.bw': 'ขาว-ดำ',
  'airender.opt.colorTone.vintage-retro': 'วินเทจ / เรโทร',
  'airender.opt.colorTone.pastel': 'พาสเทล',
  'airender.opt.colorTone.cinematic': 'แบบภาพยนตร์',
  'airender.opt.colorTone.modern-warm': 'โมเดิร์นโทนอุ่น',
  'airender.opt.colorTone.luxury': 'หรูหราระดับพรีเมียม',
  'airender.opt.colorTone.japandi': 'จาแปนดิมินิมอล',
  'airender.opt.colorTone.premium-apartment': 'อพาร์ตเมนต์ระดับพรีเมียม',
  'airender.opt.colorTone.kitchen-showroom': 'โชว์รูมครัว',
  'airender.opt.colorTone.scandinavian': 'สแกนดิเนเวียนโทนสว่าง',
  // ป้ายระดับโมเดล AI (04h)
  'airender.opt.quality.very-high': 'คุณภาพสูงมาก',
  'airender.opt.quality.high': 'คุณภาพสูง',
  'airender.opt.quality.fair': 'คุณภาพพอใช้',
  'airender.opt.price.very-expensive': 'ราคาแพงมาก',
  'airender.opt.price.expensive': 'ราคาแพง',
  'airender.opt.price.medium': 'ราคาปานกลาง',
  'airender.opt.price.cheap': 'ราคาถูก',
  'airender.opt.speed.fast': 'เรนเดอร์เร็ว',
  'airender.opt.speed.medium': 'เรนเดอร์ปานกลาง',
  'airender.opt.speed.slow': 'เรนเดอร์ช้า',
  'airender.opt.modelTag.new': 'ใหม่',
  // คำแนะนำการกรอก + ตัวอย่างพรอมป์ (04h)
  'airender.fillExample': 'เติมตัวอย่างอัตโนมัติ',
  // ฉากกลางแจ้ง (10f/04g)
  'airender.archSection': 'ฉากสถาปัตยกรรม',
  'airender.landSection': 'ฉากภูมิทัศน์',
  'airender.fieldScene': 'ฉาก',
  'airender.fieldArchSurrounding': 'อาคารโดยรอบ',
  'airender.fieldArchActivity': 'กิจกรรม (คน/รถ)',
  'airender.fieldArchGround': 'พื้นผิว',
  'airender.fieldSky': 'ท้องฟ้า',
  'airender.fieldLandTerrain': 'ภูมิประเทศ',
  'airender.fieldLandWater': 'องค์ประกอบน้ำ',
  'airender.fieldLandHeroTree': 'ต้นไม้เด่น',
  'airender.fieldLandGround': 'พื้นดิน',
  'airender.sceneVsEnvNote': 'เมื่อเลือก "ฉาก" ด้านล่าง (ไม่ใช่ อัตโนมัติ) จะใช้แทน "สภาพแวดล้อม" — "สภาพแวดล้อม" ใช้เฉพาะเมื่อ "ฉาก" = อัตโนมัติ หรือเลือก "อื่น ๆ" เพื่อบรรยายเอง',
  'airender.opt.archScene.auto': 'อัตโนมัติ',
  'airender.opt.archScene.urban-heritage-street': 'ถนนเมืองเก่า',
  'airender.opt.archScene.old-town': 'ย่านเมืองเก่า',
  'airender.opt.archScene.modern-city': 'เมืองสมัยใหม่',
  'airender.opt.archScene.tourist-street': 'ถนนท่องเที่ยว',
  'airender.opt.archScene.garden-courtyard': 'ลานสวน',
  'airender.opt.archSurrounding.auto': 'อัตโนมัติ',
  'airender.opt.archSurrounding.low-rise-nearby': 'อาคารเตี้ยใกล้เคียง',
  'airender.opt.archSurrounding.high-rise-far': 'ตึกสูงไกลออกไป',
  'airender.opt.archSurrounding.mixed': 'ผสม',
  'airender.opt.archSurrounding.none': 'ไม่มี',
  'airender.opt.archActivity.auto': 'อัตโนมัติ',
  'airender.opt.archActivity.none': 'ไม่มี',
  'airender.opt.archActivity.light': 'เบาบาง',
  'airender.opt.archActivity.medium': 'ปานกลาง',
  'airender.opt.archActivity.busy': 'พลุกพล่าน',
  'airender.opt.archGround.auto': 'อัตโนมัติ',
  'airender.opt.archGround.stone-pavement': 'พื้นปูหิน',
  'airender.opt.archGround.sidewalk': 'ทางเท้า',
  'airender.opt.archGround.asphalt': 'ถนนยางมะตอย',
  'airender.opt.sky.auto': 'อัตโนมัติ',
  'airender.opt.sky.golden-hour': 'ช่วงแสงทอง',
  'airender.opt.sky.daylight': 'กลางวัน',
  'airender.opt.sky.clear': 'ฟ้าใส',
  'airender.opt.sky.overcast': 'ฟ้าครึ้ม',
  'airender.opt.sky.night': 'กลางคืน',
  'airender.opt.landScene.auto': 'อัตโนมัติ',
  'airender.opt.landScene.forest': 'ป่าไม้',
  'airender.opt.landScene.streamside': 'ริมลำธาร',
  'airender.opt.landScene.mountain': 'ภูเขา',
  'airender.opt.landScene.japanese-garden': 'สวนญี่ปุ่น',
  'airender.opt.landScene.park': 'สวนสาธารณะ',
  'airender.opt.landScene.old-village': 'หมู่บ้านเก่า',
  'airender.opt.landScene.lakeside': 'ริมทะเลสาบ',
  'airender.opt.landTerrain.auto': 'อัตโนมัติ',
  'airender.opt.landTerrain.forest-clearing': 'ที่โล่งในป่า',
  'airender.opt.landTerrain.gentle-hill': 'เนินลาด',
  'airender.opt.landTerrain.streamside': 'ริมลำธาร',
  'airender.opt.landTerrain.rocky': 'พื้นที่หิน',
  'airender.opt.landTerrain.paved-path': 'ทางเดินปูหิน',
  'airender.opt.landWater.auto': 'อัตโนมัติ',
  'airender.opt.landWater.none': 'ไม่มี',
  'airender.opt.landWater.stream-beside': 'ลำธารด้านข้าง',
  'airender.opt.landWater.stream-front': 'ลำธารด้านหน้า',
  'airender.opt.landWater.pond-front': 'บ่อน้ำด้านหน้า',
  'airender.opt.landWater.waterfall-back': 'น้ำตกด้านหลัง',
  'airender.opt.landHeroTree.auto': 'อัตโนมัติ',
  'airender.opt.landHeroTree.none': 'ไม่มี',
  'airender.opt.landHeroTree.ancient-pine-behind': 'สนโบราณด้านหลัง',
  'airender.opt.landHeroTree.red-maple': 'เมเปิลแดง',
  'airender.opt.landHeroTree.bamboo': 'ไผ่',
  'airender.opt.landHeroTree.natural-forest': 'ป่าธรรมชาติ',
  'airender.opt.landGround.auto': 'อัตโนมัติ',
  'airender.opt.landGround.stone-and-moss': 'หินและมอส',
  'airender.opt.landGround.grass': 'สนามหญ้า',
  'airender.opt.landGround.dirt': 'พื้นดิน',
  'airender.hint.renderType': 'เลือกประเภทภาพที่ต้องการสร้าง: ภายในห้อง งานสถาปัตยกรรม หรือภูมิทัศน์กลางแจ้ง',
  'airender.hint.environment': 'บริบท/ประเภทห้องรอบผลิตภัณฑ์ (เช่น ห้องนั่งเล่น ถนน) เลือก "อื่น ๆ" เพื่อกรอกเอง',
  'airender.hint.lighting': 'สไตล์แสงของภาพ — เลือก 0 หรือหลายรายการ; เว้นว่าง = ให้ AI ตัดสินใจ',
  'airender.hint.colorTone': 'โทนสี/สไตล์สีโดยรวม — เลือก 0 หรือหลายรายการ; เว้นว่าง = ให้ AI ตัดสินใจ',
  'airender.hint.materials': 'วัสดุที่ต้องการเน้นในภาพ — เลือกได้หลายอย่าง; "คงเดิม" = ยึดวัสดุต้นฉบับ',
  'airender.hint.model': 'เลือกโมเดล AI ที่ใช้เรนเดอร์ (จากผู้ให้บริการที่คุณกรอกคีย์ไว้)',
  'airender.hint.negative': 'ระบุสิ่งที่ไม่ต้องการให้ปรากฏ (เช่น คน ตัวอักษร ความผิดเพี้ยน)',
  'airender.hint.desc.interior': 'โปรดอธิบายประเภทห้อง วิธีที่เฟอร์นิเจอร์ยึดกับผนัง/พื้น/เพดาน อุปกรณ์ที่ต้องเพิ่ม ของตกแต่ง ความรู้สึกของพื้นที่ และรายละเอียดที่ต้องคงไว้',
  'airender.hint.desc.architecture': 'โปรดอธิบายตัวอาคาร บริบทโดยรอบ กิจกรรมในฉาก วัสดุหลัก และรายละเอียดที่ห้ามทำให้เสียดีไซน์ต้นฉบับ',
  'airender.hint.desc.landscape': 'โปรดอธิบายภูมิประเทศ ต้นไม้ น้ำ หิน พื้นดิน ฉากหลัง และตำแหน่งของวัตถุหลักในฉาก ควรระบุชัดว่าอะไรอยู่ด้านหน้า ด้านข้าง หรือด้านหลังวัตถุหลัก',
  'airender.ex.interior.1': 'ครัวเปิดโล่งสไตล์โมเดิร์น เต็มไปด้วยแสงธรรมชาติจากผนังกระจกบานใหญ่ ชุดตู้ไม้ติดตั้งแนบผนังอย่างลงตัว ท็อปเคาน์เตอร์ปูหินควอตซ์ลายเมฆ มีเครื่องดูดควัน บนเคาน์เตอร์มีต้นไม้กระถางเล็ก ตะกร้าผลไม้สด เครื่องชงกาแฟเอสเพรสโซ และเครื่องผสมอาหาร KitchenAid เป็นจุดเด่น ข้างตู้เย็นมีต้นมอนสเตอราใบแฉกต้นใหญ่สวยงาม มีแม่บ้านชาวเวียดนามกำลังมองดูอาหาร มีเด็กทารกชาวเวียดนามเกาะขาแม่ บนเคาน์เตอร์เกาะกลางมีถาดอาหารอร่อยจัดเต็ม',
  'airender.ex.interior.2': 'ตู้ครัวติดตั้งยึดกับผนังสองด้านที่ตั้งฉากกันของห้องครัว ภายในตู้มีเครื่องดูดควัน เตาอบ และไมโครเวฟแบบฝัง บนเคาน์เตอร์มีเตาแม่เหล็กไฟฟ้า ต้นไม้เล็ก และเครื่อง KitchenAid กลางห้องมีเกาะครัวเข้าชุดกับท็อปหิน พื้นที่ควรอบอุ่น สะอาด ระดับพรีเมียม และไม่มีของตกแต่งมากเกินไป',
  'airender.ex.interior.3': 'ตู้วางทีวีติดตั้งแนบผนังหลักของห้องนั่งเล่น โดยรอบเป็นผนังโทนสว่าง พื้นไม้อบอุ่น โซฟาเตี้ยด้านหน้า และโต๊ะกลางตัวเล็ก บนตู้มีของตกแต่งเบา ๆ ต้นไม้เล็ก และไฟส่องผนังนุ่มนวล พื้นที่ควรโมเดิร์น เป็นระเบียบ หรูหรา และคงดีไซน์ตู้เดิมไว้',
  'airender.ex.interior.4': 'ตู้เสื้อผ้าวางแนบผนังในห้องนอน ข้าง ๆ มีโต๊ะเครื่องแป้งเล็กและกระจก ห้องมีเตียงเตี้ย ผ้าม่านโทนสว่าง พื้นไม้ และแสงเหลืองนวล พื้นที่ควรอบอุ่น ผ่อนคลาย สะอาด และพรีเมียม ต้องคงผัง สัดส่วน และวัสดุหลักของชุดตู้ไว้',
  'airender.ex.landscape.1': 'ศาลาพักผ่อนไม้แบบดั้งเดิมตั้งอยู่กลางสวนนิเวศเขตร้อนอันเขียวชอุ่ม ตัวอาคารตั้งมั่นบนพื้นโรยกรวดและก้อนหินธรรมชาติ ล้อมรอบด้วยพุ่มเฟิร์นและหินเคลือบมอส ข้าง ๆ มีลำธารเล็กไหลริน แสงทองยามอาทิตย์อัสดงส่องลอดใบไม้ ทอดเงานุ่มนวลลงบนหลังคากระเบื้อง',
  'airender.ex.landscape.2': 'วัดไม้ตั้งอยู่ในป่าอันเงียบสงบ ข้างวัดมีลำธารเล็กไหลผ่าน ด้านหน้ามีหินธรรมชาติและมอสเขียว ด้านหลังวัดมีต้นสนเก่าแก่ขนาดใหญ่ รอบ ๆ เป็นป่าเขียวหนาแน่นแต่ไม่บังตัวอาคาร บรรยากาศสงบ เป็นธรรมชาติ และมีมิติ',
  'airender.ex.landscape.3': 'พาวิลเลียนตั้งอยู่กลางสวนสาธารณะกว้าง โดยรอบมีสนามหญ้า ทางเดินปูหิน ต้นไม้เตี้ย และต้นไม้ใหญ่ไม่กี่ต้นเป็นฉากหลัง ด้านหน้ามีลานโล่งเพื่อมองเห็นตัวอาคารทั้งหมด ภูมิทัศน์ควรสว่าง โปร่ง เป็นธรรมชาติ และเหมาะกับภาพนำเสนอสถาปัตยกรรมกลางแจ้ง',
  'airender.ex.landscape.4': 'อาคารตั้งอยู่บนเนินเขาลาดเอียง มองออกไปเห็นหุบเขาเขียวไกลออกไป โดยรอบมีหญ้า หินธรรมชาติ พุ่มไม้เตี้ย และต้นไม้ใหญ่ไม่กี่ต้น ฉากหลังมีภูเขาเลือนรางและท้องฟ้าใส วัตถุหลักควรโดดเด่นและไม่ถูกต้นไม้บัง',
  'airender.ex.architecture.1': 'ซุ้มร้านไม้สไตล์เอเชียตะวันออกดั้งเดิมโดดเด่นบนถนนคนเดินปูหินที่คึกคัก โดยรอบเป็นอาคารพาณิชย์สมัยใหม่เรียงราย พร้อมแสงไฟถนนเลือนรางไกลออกไป บรรยากาศยามโพล้เพล้ แสงเหลืองนวลจากไฟ LED ฝังฝ้าสาดลงบนพื้นถนน สร้างการผสานอย่างลงตัวระหว่างสถาปัตยกรรมคลาสสิกกับจังหวะชีวิตเมือง',
  'airender.ex.architecture.2': 'ร้านกาแฟสไตล์ย้อนยุคตั้งอยู่หัวมุมย่านที่มีผู้คนพลุกพล่าน ใกล้ร้านมีบ้านเตี้ยไม่กี่หลัง ไกลออกไปเป็นอาคารสูงสมัยใหม่ หน้าร้านมีทางเท้าปูหิน มีคนเดินและรถอยู่ด้านหลังบ้าง แต่ไม่บังหน้าร้าน ตัวอาคารต้องคงหลังคาโค้ง โครงไม้ กรอบกระจก และโซนเคาน์เตอร์ด้านหน้าให้ชัดเจน',
  'airender.ex.architecture.3': 'โชว์รูมเฟอร์นิเจอร์ตั้งอยู่บนถนนสมัยใหม่ ด้านหน้าหันออกถนนใหญ่ มีทางเท้ากว้าง ต้นไม้ในเมือง และรถจอดริมถนนไม่กี่คัน สองข้างเป็นอาคารเตี้ยสมัยใหม่ พื้นที่ควรสะอาด พรีเมียม และเหมาะกับภาพนำเสนอเชิงพาณิชย์',
  'airender.ex.architecture.4': 'บ้านพักตากอากาศไม้ริมทะเลสาบ โดยรอบมีต้นไม้ ทางเดินปูหิน และลานเล็กด้านหน้า ด้านหลังเป็นป่าโปร่งและผืนน้ำสะท้อนแสง ต้องคงรูปทรงสถาปัตยกรรม หลังคา วัสดุไม้ และสัดส่วนของอาคารต้นฉบับไว้',
  'airender.opt.environment.other': 'อื่น ๆ',
  'airender.opt.material.keep': 'คงเดิมตามภาพต้นฉบับ',
  'airender.opt.material.wood': 'ไม้',
  'airender.opt.material.glass': 'กระจก',
  'airender.opt.material.stone': 'หิน',
  'airender.opt.material.brick': 'อิฐ',
  'airender.opt.material.marble': 'หินอ่อน',
  'airender.opt.material.aluminum-glass': 'อะลูมิเนียม-กระจก',
  'airender.opt.material.ceramic': 'เซรามิก',
  'airender.opt.material.bamboo-rattan': 'ไม้ไผ่ / หวาย',
  'airender.opt.material.composite-panel': 'แผ่นคอมโพสิต',
  'airender.opt.material.laterite': 'ศิลาแลง',
  'airender.opt.material.concrete': 'คอนกรีต',
};

export const VIEWER_MESSAGES: Record<Locale, Dict> = { vi, en, ru, zh, th };
